import { MetaDataConfigObject, TransformedConfig, configurationAttributeType, newConfigurationNames } from "../types";
import { getCurrentDateWithTime } from "../utils/utils";
import * as yup from "yup"
import * as Sentry from "@sentry/react";
import { ChannelkartNetworkDelete, ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut, envGetRequest, META_DATA_BATCH_API, META_DATA_PLAYGROUND_API } from "./networkService";
import { deepClone } from "@mui/x-data-grid/utils/utils";
import { manageUpdateAccessObj } from "../features/manageUpdateAccess/manageUpdateAccessTypes";
import { featureType, portalFeatureRegistry } from "../features/manageRole/ManageRoleRegistry";
import { allNavbarOptions, AllSidebarOptions } from "../configurations/allSidebarOptions";
import { adminPanelOptionConfigRegistry } from "../features/adminPanel/AdminPanel";
import { adminPanelConfigOptionType } from "../components/adminPanelLayout/adminPanelTypes";
import { Role } from "../components/userModal/userModalType";
import { sfaConfigOptions, uiConfigOptions } from "../components/uiConfigSidebar/UiConfigSidebar";
import { portalConfig } from "../stateManagement/reducers/portalConfigReducer";
import { validateWithOtp } from "../stateManagement/actions/validateOtpPopupActions";
import { openPopup } from "../stateManagement/actions/popupActions";
import { getAccessToken, getLOBClientConfig, getLob, logoutUser } from "./authenticationService";
import { updateConfigRequestBody } from "./managePoliciesService";
import { metaDataBatchPayload } from "../types/types";
import { sendConfigAnalyticsEvent } from "./updateMetaConfigService";
import axios from "axios";
import { setCurrentAppType, setCurrentRole } from "../stateManagement/actions/roleActions";
import { getConfigFromClientConfig } from "./bannerServices";
import { AppOptionType, OptionType } from "../features/manageHomepage/ManageHomePageTypes";
import { otherConfigOptionsAttributes, otherConfigOptionsAttributesFeature } from "../features/salescodeStudio/mandatoryConfigs/configSetupScreen/widget/configBottomBar";
import { featureConfiguration } from "../components/newPortal/UiConfigOptions";


export async function getUiConfigOptions()
 {
    try{
        const domainType = "salescode_studio_config";
        const configName = "uiConfigOptions";
        const response = await ChannelkartNetworkGet(`${UI_CONFIG_API_BASE_URL}/${domainType}`);
        if (response?.status === 200){
            return response.data?.[domainType]?.[configName]?.value ?? [];
        }
        else{
            return [];
        }
    }
    catch(err) {
        throw new Error("Failed to fetch UI config options");
    }
}

    

export async function postConfiguration(configurationType: string, config: configurationAttributeType<any>[],verifiedUser?: manageUpdateAccessObj,filterValues?:{filter1:string,filter2:string,filter3:string}): Promise<any> {
    try{
        let url=verifiedUser?`/metadata?verifiedBy=${verifiedUser.phoneNumber}`:`/metadata`;
        const filterUrl= "/metadata/filters?name=tab"
        const responses=[];
        const actionData=[];

           let updateClientConfigData = [{
                "domainName": "clientconfig",
                "domainType": configurationType,
                "domainValues": config,
                "lob": localStorage.getItem("lob"),
                "extendedAttributes":{
                    "activity":"",
                    "mobTime":getCurrentDateWithTime(),
                    "designation":'admin'
                }
            }];
        const resp = await ChannelkartNetworkPost(url, updateClientConfigData);

        responses.push(resp);
        actionData.push({
            "lob": localStorage.getItem("lob"),
            "domainName": "clientconfig",
            "domainType": configurationType,
            "domainValues": config,
        });
        if(filterValues){
            const filteReqBody = {
                domainName: "filters",
                domainType: "tab",
                domainValues: getFilters(filterValues),
                lob: localStorage.getItem("lob")
            };
            const filterResp = await ChannelkartNetworkPost(filterUrl, filteReqBody);
            responses.push(filterResp);
            actionData.push(filteReqBody);

        }

        const analyticsBody={
            "response":responses,
            "actionType": "config_updated",
            "actionData": actionData,
            "source": "Kpi-dashboard",
            "extendedAttributes": {
                "activity": "",
                "mobTime": getCurrentDateWithTime(),
                "designation": "admin",
                "userDetail":verifiedUser
            }
        }
        await ChannelkartNetworkPost("/v1/analytics", analyticsBody);
        return resp;
    }catch(err)
    {
        // Sentry.captureException(err);
        console.log(err);
        throw new Error("Something went wrong while updaing configuration");
    }
}
export async function updateConfiguration(configurationType: string, config: configurationAttributeType<any>[],verifiedUser?: manageUpdateAccessObj,filterValues?:{filter1:string,filter2:string,filter3:string}): Promise<any> {
    try{
        const url = verifiedUser? `/metadata/clientconfig?name=${configurationType}&verifiedBy=${verifiedUser.phoneNumber}`: `/metadata/clientconfig?name=${configurationType}`;
        const filterUrl= "/metadata/filters?name=tab" + (verifiedUser? `&verifiedBy=${verifiedUser.phoneNumber}` : "");
        const tabFiltersUrl="/metadata/clientconfig?name=tab_filters" + (verifiedUser? `&verifiedBy=${verifiedUser.phoneNumber}` : "");

        const responses=[];
        const actionData=[];
        const updateClientConfigData = {
            domainName: "clientconfig",
            domainType: configurationType,
            domainValues: config,
            lob: localStorage.getItem("lob"),
        };        
        const resp = await ChannelkartNetworkPut(url, updateClientConfigData);
        responses.push(resp);
        actionData.push({
            "lob": localStorage.getItem("lob"),
            "domainName": "clientconfig",
            "domainType": configurationType,
            "domainValues": config,
        });

        if(filterValues){
            const filteReqBody = {
                domainName: "filters",
                domainType: "tab",
                domainValues: getFilters(filterValues),
                lob: localStorage.getItem("lob")
            };
            const updateClientConfigFilters = {
                domainName: "clientconfig",
                domainType: "tab_filters",
                domainValues: getClientConfigFilters(filterValues),
                lob: localStorage.getItem("lob"),
            };
            const clientConfigFilterResp=await ChannelkartNetworkPut(tabFiltersUrl, updateClientConfigFilters);
            responses.push(clientConfigFilterResp);
            actionData.push(updateClientConfigFilters);

           const filterResp= await ChannelkartNetworkPut(filterUrl, filteReqBody);
           responses.push(filterResp);
           actionData.push(filteReqBody);
        }


        const analyticsBody={
            "response":responses,
            "actionType": "config_updated",
            "actionData": actionData,
            "source": "Kpi-dashboard",
            "extendedAttributes": {
                "activity": "",
                "mobTime": getCurrentDateWithTime(),
                "designation": "admin",
                "userDetail":verifiedUser
            }
        }
        await ChannelkartNetworkPost("/v1/analytics", analyticsBody);
        
        return resp;
    }catch(err)
    {
        // Sentry.captureException(err);
        console.log(err);
        throw new Error("Something went wrong while updating config");
    }
}
export async function deleteConfig(configName:newConfigurationNames){
   try{
    const body = {
        domainName: "clientconfig",
        domainType: configName+"_preview",
        domainValues: null,
        lob: localStorage.getItem("lob")
    }
    const url =  `/metadata/clientconfig?name=${configName+"_preview"}`;
    const resp = await ChannelkartNetworkDelete(url, body);
    return resp;
   }catch(err){
    // Sentry.captureException(err);
    console.log(err)
   }
}

export const createValidation =(attr:configurationAttributeType)=>{
    try{
    switch(attr.type){
        case 'string': if (attr.possibleVals) {
            if (attr.possibleVals.length > 1) {
                const regex = new RegExp(attr.possibleVals.join("|"), 'gi');
                return yup.string().test('non-negative', 'The number should not be negative', (value) => {
                    if (!value) return true; // Ignore empty values here, use .required() elsewhere if necessary
                    const num = parseFloat(value);
                    if (!isNaN(num)) {
                        return num >= 0;
                    }
                    return true; // If it's not a number, pass the test
                }).matches(regex);
            } else {
                if (attr.possibleVals[0] === 'string') {
                    return yup.string().test('non-negative', 'The number should not be negative', (value) => {
                        if (!value) return true;
                        const num = parseFloat(value);
                        if (!isNaN(num)) {
                            return num >= 0;
                        }
                        return true;
                    });
                } else {
                    const regex = new RegExp(attr.possibleVals.join("|"), 'gi');
                    return yup.string().test('non-negative', 'The number should not be negative', (value) => {
                        if (!value) return true;
                        const num = parseFloat(value);
                        if (!isNaN(num)) {
                            return num >= 0;
                        }
                        return true;
                    }).matches(regex);
                }
            }
        }else{
            return yup.string().test('non-negative', 'The number should not be negative', (value) => {
                if (!value) return true;
                const num = parseFloat(value);
                if (!isNaN(num)) {
                    return num >= 0;
                }
                return true;
            });
        }
        
        break;
        case 'boolean': 
        return yup.boolean();
        case "number": {
            return yup.number().positive();
        }
        case 'integer': if (attr.possibleVals) {
            if (attr.possibleVals.length === 2 && attr.possibleVals[1] === 'n') {
                return yup.number().min(attr.possibleVals[0]).positive();
            } else {
                if (attr.possibleVals.length) {
                    return yup.number().test('exact number', "The number should be some specific values", (value) => {
                        if (value || value === 0) {
                            const val = value.toString();
                            const regex = new RegExp(attr.possibleVals.join("|"), 'gi');
                            return regex.test(val);
                        } else 
                            return false;
                    }).positive();
                } else {
                    return yup.number().positive();
                }
            }
        }
        break;
        case 'list': if(attr.possibleVals){
            if(attr.possibleVals.length===1){
                switch(attr.possibleVals[0]){
                    case 'string[]':return yup.array().of(yup.string()) ;
                    case 'number[]':return yup.array().of(yup.number());
                    case Array.isArray(attr.possibleVals[0]) : return yup.array();
                    default :  return yup.array();
                }
            }
        }
        break;
        case 'object':if(attr.possibleVals){
            if(typeof attr.possibleVals[0]==='object' && !Array.isArray(attr.possibleVals[0])){
                return yup.object();
            }
        }
    }
}catch(err){
    // Sentry.captureException(err);
        
}
}

export async function getNewConfiguration(configurationType: newConfigurationNames): Promise<any> {
    try{
        return getMetaDataConfig("clientconfig",configurationType);
    }catch(err){
        // Sentry.captureException(err);
        console.log("err===",err)
        return {domainValues:[]}
    }
}

export async function getUpdateNewConfiguration(configurationType: newConfigurationNames): Promise<any> {
    try{
        return getMetaDataConfig("otpverify",configurationType);
    }catch(err){
        // Sentry.captureException(err);
        console.log("err===",err)
        return {domainValues:[]}
    }
}

export async function getHomePageConfiguration(): Promise<any> {
    try{
        let clientConfig = await getMetaDataConfig("clientconfig");
        return {homepageConfig:clientConfig.find((config:{domainType:string})=>config.domainType==="retailer_app_layout_configuration")?.domainValues?.find((config:{name:string})=>config.name==="homePageWidget"),
        appLayoutConfiguration:clientConfig.find((config:{domainType:string})=>config.domainType==="retailer_app_layout_configuration")?.domainValues};
    }catch(err){
        // Sentry.captureException(err);
        console.log("err===",err)
    }
}
const validateConfigValueNew = (value: any, defaultValueType?: any,possibleVals?:any) => {
    possibleVals = possibleVals ?? [];
  
    const parsePossibleValsAsRegex = (): RegExp[] => {
        if (Array.isArray(possibleVals)) {
            return possibleVals
                .filter((val) => typeof val === "string" && val.startsWith("^")) 
                .map((val) => new RegExp(val));
        }
        return [];
    };

    const regexPatterns = parsePossibleValsAsRegex();

    const isValidAgainstAllRegex = (val: any): boolean => {
        if (regexPatterns.length > 0) {
            return regexPatterns.every((regex) => regex.test(val.toString()));
        }
        return true;
    };

    const isValidAgainstTypes = (val: any): boolean => {
        if (Array.isArray(possibleVals)) {
            return possibleVals.includes(typeof val);
        }
        return true;
    };
    if (defaultValueType === "boolean" ) {
        return typeof value === "boolean";
    }
    if (defaultValueType === "number") {
     
        if (possibleVals.length > 0) {
            return isValidAgainstAllRegex(value) || isValidAgainstTypes(value);
        }
        return typeof value === "number";
    }
  
    if (defaultValueType === "string") {
 
        if (possibleVals.length > 0) {
            return isValidAgainstAllRegex(value) || isValidAgainstTypes(value);
        }
        return typeof value === "string";
    }

    if (defaultValueType=== 'array') {
        return Array.isArray(value);
    }

    if (defaultValueType=== 'object') {
        return typeof value === "object" && value !== null && !Array.isArray(value);
    }

    return true;
}

export const convertValuesToConfigNew = (
  givenValues: { [key: string]: configurationAttributeType<any> },
  mainConfig: configurationAttributeType[],
  defaultValues?: { [key: string]: configurationAttributeType<any> }
): { result: configurationAttributeType[]; failedValidations: string[];missingFromGlobal:string[] } => {
    const failedValidations: string[] = [];
    const missingFromGlobal: string[] = [];
  let result: configurationAttributeType[] = deepClone([...mainConfig]);
  Object.keys(givenValues).forEach((val: string) => {
      if (givenValues[val]?.isValueUpdated) {
        if (defaultValues ) { //   || true
            if (defaultValues?.hasOwnProperty(val) ) {//   || true
            
                if (
                  
                    validateConfigValueNew(givenValues[val].value, defaultValues?.[val]?.type,defaultValues?.[val]?.possibleVals)
                ){
                    const configObject = result.find((config) => config.name === val);
                    if (configObject) {
                        configObject.value = givenValues[val].value;
    
                        if (givenValues[val].domainType) {
                            configObject.domainType = givenValues[val].domainType;
                        }
                    } else {
                        const newConfig = {
                            ...givenValues[val]
                        };
    
                        if (givenValues[val].domainType) {
                            newConfig.domainType = givenValues[val].domainType;
                        }
                        result.push(newConfig);
                    }
                } else {
                    failedValidations.push(val);
                  }
            }else{
              missingFromGlobal.push(val)
            }
        }
      }
  });
  return { result, failedValidations,missingFromGlobal };
};
const validateConfigValue = (value: any, defaultValue?: any) => {
    //return true if value is different from it's default value (as diff value will make impact in app)
    if (typeof defaultValue === "boolean" ) {//&& value !== defaultValue
        return true;
    }

    //returns false for boolean value false, undefined, null etc
    if (!value && value !== 0) {
        return false;
    }

    if (typeof value === 'string') {
        // Check if the value is an empty string
        return value.trim() !== '';
    }

    if (Array.isArray(value)) {
        // Check if the value is an array and if all elements are empty strings
        return !value.every((item) => typeof item === 'string' && item.trim() === '');
    }

    if (typeof value === 'object' && value !== null) {
        // Check if the value is an object and if it is not empty
        return Object.keys(value).length > 0;
    }

    return true;
}

export const convertValuesToConfig = (
  givenValues: { [key: string]: configurationAttributeType<any> },
  mainConfig: configurationAttributeType[],
  defaultValues?: { [key: string]: configurationAttributeType<any> }
): configurationAttributeType[] => {
  let result: configurationAttributeType[] = deepClone([...mainConfig]);
  Object.keys(givenValues).forEach((val: string) => {
    if (
      validateConfigValue(givenValues[val].value, defaultValues?.[val]?.value)
    ) {
      const configObject = result.find((config) => config.name === val);
      if (configObject) {
        configObject.value = givenValues[val].value;

        if (givenValues[val].domainType) {
          configObject.domainType = givenValues[val].domainType;
        }
      } else {
        const newConfig = {
          ...givenValues[val],
          isValueUpdated: undefined,
        };

        if (givenValues[val].domainType) {
          newConfig.domainType = givenValues[val].domainType;
        }
        result.push(newConfig);
      }
    } else {
      result = result.filter((config) => config.name !== val);
    }
  });
  return result;
};


export function getFilters(filterValues:{filter1:string,filter2:string,filter3:string}) {
    try {
    var filters = [];
     const {filter1 ,
     filter2 ,
     filter3}=filterValues

    if(filter1 && filter1 !== "none") {
        filters.push(filter1);
        if(filter2 && filter2 !== "none") {
            filters.push(filter2);
            if(filter3 && filter3 !== "none") {
                filters.push(filter3);
            }
        }
    }
    
    

    return filters;
} catch (err) {
    // Sentry.captureException(err);
    return err
}
}
export function getClientConfigFilters(filterValues:{filter1:string,filter2:string,filter3:string}):any[] {
    let filters:any[]= [
        {
          "name": "tabFilters",
          "type": "List",
          "value": [
            
          ],
          "docUrl": "",
          "description": "arrangement of tab filters",
          "defaultValue": [],
          "possibleVals": []
        }
      ];
     const {filter1 ,
     filter2 ,
     filter3}=filterValues

    if(filter1 && filter1 !== "none") {
        filters[0]["value"].push({"name":filter1});
        if(filter2 && filter2 !== "none") {
            filters[0]["value"].push({"name":filter2});
            if(filter3 && filter3 !== "none") {
                filters[0]["value"].push({"name":filter3});
            }
        }
    }
    
    

    return filters;
}

export async function getMetaData(domainName:string,domainType:string){
    try{
    const resp =await getMetaDataConfig(domainName,domainType);
    return resp?.domainValues;
}catch(err){
    console.log(err)
    // Sentry.captureException(err);
    return err;
}
}



export async function getMetaDataConfig(domainName:string,domainType?:string){
    try{
        const metaData = await ChannelkartNetworkGet("/metadata/"+domainName);
        if(!domainType){
            return metaData.data.features;
        }
        const resp = metaData.data.features.find((config:any)=>config.domainType === domainType);
        return resp
    }catch(err){
        console.log(err)
        // Sentry.captureException(err);
    }
}

export async function fetchCurrentUserData(){
    try{
        const loginId = JSON.parse(localStorage.authContext).user.loginId;
        const url = `/users?filter=loginId:${loginId}`;
        const response = await ChannelkartNetworkGet(url);
        return response.data.features[0];
    }catch(err){
        console.log(err);
        // Sentry.captureException(err);
    }
}
export async function fetchCurrentLobCountry() {
    try {
        const configData = await getMetaData("clientconfig", "customer_configuration");
        const deploymentCountryConfig = configData.find((ele: any) => ele.name === "deploymentCountry");
        if (deploymentCountryConfig && deploymentCountryConfig.value) {
            localStorage.setItem("deploymentCountry", deploymentCountryConfig.value);
        } else {
            localStorage.setItem("deploymentCountry", "{}");
        }
    } catch (err) {
        console.log(err);
        localStorage.setItem("deploymentCountry", "{}");
        Sentry.captureException(err);
    }
}


export function isRoleConfigEnabled(clientConfig: any[]){
    return Boolean(clientConfig?.find((config: { domainType: string }) => config.domainType === "config")?.domainValues?.[0]?.roleBasedAccess) ?? false;
}
export function getUserRolesBasedOnAccess(roleBasedAccess: boolean,currentUserData: any){
    const roles =  (currentUserData?.roles?.filter((accessRole: Role) => Boolean(accessRole.name) ).map((accessRole: Role) => accessRole.name)) ?? [];
    const designations = currentUserData?.designation ?? [];
    return roleBasedAccess? roles : designations;
}
export async function getPortalRoleConfig(): Promise<portalConfig>{
    try{
        
        const currentUserData = JSON.parse(localStorage.getItem("authContext") ?? "{}")?.user;
        const clientConfig = await getMetaDataConfig("clientconfig");
        const roleBasedAccess = isRoleConfigEnabled(clientConfig);
        let roles = getUserRolesBasedOnAccess(roleBasedAccess,currentUserData);
        const roleOrderLayout = clientConfig.find((config: {domainType: string}) => {
            return config.domainType === "portal_layout_order_configuration";
        })?.domainValues;
        const designations = currentUserData?.designation ?? [];
        const currentRoles = currentUserData?.roles?.map((role: any) => role.id.toLowerCase()) ?? [];
        const allowedRoleLogin = clientConfig?.find((config:{domainType:string})=>config.domainType === "portal_configuration")?.domainValues?.find((item:{name:string})=>item.name === "allowedRoleLogin")?.value ?? null;
        if (allowedRoleLogin) {
            const matchingDesignations = designations.filter((designation: string) => allowedRoleLogin.hasOwnProperty(designation));
            if (matchingDesignations.length > 0) {
                const isRoleAllowed = matchingDesignations.some((designation: string) =>
                    allowedRoleLogin[designation].some((allowedRole: string) => currentRoles.includes(allowedRole.toLowerCase()))
                );
                if (!isRoleAllowed) {
                    return { featureConfig: [], layoutConfig: [], roleOrderLayout: [] };
                }
            }
        }
        if(designations.includes("admin")){
            const featureConfig = [...portalFeatureRegistry];
            const uiConfigIds = uiConfigOptions.map((uiConfgObj) => {
                return uiConfgObj.id;
            })
            const sfaConfigIds = sfaConfigOptions.map((sfaConfigObj) => {
                return sfaConfigObj.id;
            })
            const allUiConfigIds = [...uiConfigIds,...sfaConfigIds];
            const layoutName = `admin_portal_layout_configuration`;
            const roleLayoutConfig = clientConfig.find((config: { domainType: string }) => config.domainType === layoutName);
            const layoutConfig = convertToPortalLayout(featureConfig,allUiConfigIds,roleOrderLayout,roleLayoutConfig);
            const featureIDList = ["createPrimaryOrder", "viewPrimaryOrders","grn","manageOrder","saleReturns","manageInvoice","createSecondaryOrder","realTimeStocks","batchAndExpiryManagement","stockTypeUpdate","manualStockUpdate","auditTrails","viewClaimsStatus","createNewClaim","managePrimaryOrder","approvePosts","companyPosts","scaiDashboard"];
            const layoutIDList = ["Sale","Delivery","Credit","Claims","Returns","Stocks","Purchase","Primary","Secondary","Settlements", "Primary OMS","Manage Posts","SCAI Dashboard"]
            const filteredFeatureConfig = featureConfig.filter(
                (config) => !featureIDList.includes(config.name)
            );
            const filteredLayoutConfig = layoutConfig.map((config) => {
                if (config.name === "mainDashboardLayout") {
                  return {
                    ...config,
                    value: config.value.filter(
                      (item) => !layoutIDList.includes(item.id)
                    )
                  };
                }
                return config;
              });
            const configName = `admin_portal_feature_configuration`;
            const layoutConfigName = `admin_portal_layout_configuration`;
            const adminFeatureConfig = clientConfig.find((config: { domainType: string }) => config.domainType === configName);
            const adminLayoutConfig = clientConfig.find((config: { domainType: string }) => config.domainType === layoutConfigName);
            if (adminFeatureConfig && adminLayoutConfig) {
                return { featureConfig: adminFeatureConfig.domainValues[0].value, layoutConfig: adminLayoutConfig.domainValues, roleOrderLayout };
            }   
            return { featureConfig:filteredFeatureConfig, layoutConfig:filteredLayoutConfig, roleOrderLayout };
        }
        if(roles.length === 1){
            const curUserRole = roles[0];
            const configName = `${curUserRole}_portal_feature_configuration`;
            const layoutConfigName = `${curUserRole}_portal_layout_configuration`;
            const roleFeatureConfig = clientConfig.find((config: { domainType: string }) => config.domainType === configName);
            const roleLayoutConfig = clientConfig.find((config: { domainType: string }) => config.domainType === layoutConfigName);
            if(roleFeatureConfig?.domainValues?.[0]?.value && roleLayoutConfig?.domainValues){
                return {
                    featureConfig: roleFeatureConfig.domainValues[0].value,
                    layoutConfig: roleLayoutConfig.domainValues,
                    roleOrderLayout
                }
            }else if(roleFeatureConfig?.domainValues?.[0]?.value){
                const featureConfig =  roleFeatureConfig.domainValues[0].value;
                const layoutConfig = convertToPortalLayout(featureConfig,["Theme"],roleOrderLayout,roleLayoutConfig); // making Theme config to be accessible if no ui config is present
                return { featureConfig, layoutConfig, roleOrderLayout };
            }else{
                return { featureConfig: [], layoutConfig: [], roleOrderLayout};
            }
        }else{ // for roles.length > 1 or roles.length === 0
            let mergedRolesConfig: featureType[] = [];
            let mergedUiConfigs: string[] = [];
            for(let role of roles){
                const configName = `${role}_portal_feature_configuration`;
                const roleConfig = clientConfig.find((config: { domainType: string }) => config.domainType === configName);
                if(roleConfig?.domainValues?.[0]?.value){
                    mergedRolesConfig = [...mergedRolesConfig,...roleConfig.domainValues[0].value];
                }

                const layoutConfigName = `${role}_portal_layout_configuration`;
                const roleLayoutConfig = clientConfig.find((config: { domainType: string }) => config.domainType === layoutConfigName);
                if(roleLayoutConfig?.domainValues){
                    const curRoleUiConfig = roleLayoutConfig.domainValues.find((configObj: configurationAttributeType<string[]>) => {
                        return configObj.name === "uiConfigLayout";
                    })
                    if(curRoleUiConfig){
                        mergedUiConfigs = [...mergedUiConfigs, ...curRoleUiConfig.value]
                    }
                }
            }  
            const featureConfig = Array.from(new Set(mergedRolesConfig.map((item) => item.name))).map((name) => {
                return mergedRolesConfig.find((item) => item.name === name);
            }) as featureType[];
            
            const mergedUiConfigWithoutDuplicate = mergedUiConfigs.length>0 ? Array.from(new Set(mergedUiConfigs)) : ["Theme"]; //assign Theme config if no ui Config key was present 
            
            const layoutConfig = convertToPortalLayout(featureConfig,mergedUiConfigWithoutDuplicate,roleOrderLayout);
            return { featureConfig , layoutConfig , roleOrderLayout};
        }
    }catch(err){
        console.log(err);
        // Sentry.captureException(err);
        return { featureConfig: [], layoutConfig: [], roleOrderLayout: [] };
    }
    
}
export async function getConfigurationTypes() {
    try{
        // const roles = JSON.parse(localStorage.authContext).user.roles.map((accessRole: Role) => accessRole.name);
        const {featureConfig, layoutConfig} = await getPortalRoleConfig();
        // const portalRoleConfig = await getMetaDataConfig('clientconfig',`${role}_portal_feature_configuration`);
        if(featureConfig.length>0){ 
            const availablePortalOptions :featureType[] = featureConfig;
            const availableDashboardPortalOptions = availablePortalOptions.filter((portalOption) => {
                return portalOption.template === "mainDashboard";
            })
            const dashboardOptions = convertToDashboardOptions(availableDashboardPortalOptions);
            return dashboardOptions;
        }else{
            const dashboardConfig = await getMetaDataConfig('clientconfig','dashboardConfig');
            return dashboardConfig?.domainValues ?? [];
        }
    }catch(error){
        return []
    }
    
}
export async function postConfigWithDomainName(domainName: string,domainType:string,configValue: any,verifiedUser?: manageUpdateAccessObj){
    try{
        const url=verifiedUser?`/metadata?verifiedBy=${verifiedUser}`:`/metadata`;
        const requestBody = [{
            "domainName": domainName,
            "domainType": domainType,
            "domainValues": configValue,
            "lob": localStorage.getItem("lob"),
            "extendedAttributes":{
                "activity":"",
                "mobTime":getCurrentDateWithTime(),
                "designation":'admin'
            }
        }];
        const resp = await ChannelkartNetworkPost(url, requestBody);
        if(resp.status===200 || resp.status===201){
            return resp;
        }else{
            throw new Error(resp);
        }
    }catch(err){
        throw new Error("Something went wrong while updating config");
    }
}
export async function updateConfigWithDomainName(domainName: string,domainType:string,configValue: any,verifiedUser?: manageUpdateAccessObj){
    try{
        const url=verifiedUser?`/metadata/${domainName}?name=${domainType}&verifiedBy=${verifiedUser}`:`/metadata/${domainName}?name=${domainType}`;
        const requestBody = {
            "domainName": domainName,
            "domainType": domainType,
            "domainValues": configValue,
            "lob": localStorage.getItem("lob")
        };
        const resp = await ChannelkartNetworkPut(url, requestBody);
        if(resp.status===200 || resp.status===201){
            return resp;
        }else{
            throw new Error(resp);
        }
    }catch(err){
        throw new Error("Something went wrong while updating config");
    }
}
export async function updatePasswordCheckProperies(propertyName: "old.saved.password.count" | "old.password.save.check",value: string){
    try{
        const lob = localStorage.getItem("lob") ?? "";
        const url = `/v1/properties?name=${propertyName}&value=${value}&lob=${lob}`;
        const resp = await ChannelkartNetworkPut(url);
        if(resp.status===200 || resp.status===201){
            return resp;
        }else{
            throw new Error(resp);
        }
    }catch(err){
        throw new Error("Something went wrong while updating properties");
    }
    
}
export function convertToDashboardOptions(availableDashboardPortalOptions?: featureType[],roleOrderLayout?: configurationAttributeType<any[]>[],roleLayoutConfig?:any) {
    const availableSidebarOptions = availableDashboardPortalOptions? AllSidebarOptions.filter((sideBarOption) => {
        return availableDashboardPortalOptions.find((dashboardOption) => dashboardOption.name === sideBarOption.id);
    }) : AllSidebarOptions;
    const dashboardOptions = [];
    const mainDashboardLayoutConfig = roleLayoutConfig?.domainValues?.find(
    (config:any) => config.name === "mainDashboardLayout"
  )?.value;
  if (mainDashboardLayoutConfig) {
    const usedSidebarIds = new Set<string>();
    const dashboardOptions: {
      id: string;
      label: string;
      icon: string;
      sidebarOptions: string[];
    }[] = [];

    for (const layoutEntry of mainDashboardLayoutConfig) {
      const declaredSidebarIds: string[] = layoutEntry.sidebarOptions ?? [];

      // Sidebar IDs declared in layout and actually available
      const declaredAvailableSidebarIds = declaredSidebarIds.filter((id) => {
        const isAvailable = availableSidebarOptions.some((s) => s.id === id);
        if (isAvailable) usedSidebarIds.add(id);
        return isAvailable;
      });

      // Find new sidebar options under same navbarParentLabel that aren't in declared list
      const extraSidebarIds = availableSidebarOptions
        .filter(
          (option) =>
            option.navbarParentLabel === layoutEntry.id &&
            !declaredSidebarIds.includes(option.id)
        )
        .map((option) => {
          usedSidebarIds.add(option.id);
          return option.id;
        });

      const allSidebarIds = [...declaredAvailableSidebarIds, ...extraSidebarIds];

      if (allSidebarIds.length > 0) {
        dashboardOptions.push({
          id: layoutEntry.id,
          label: layoutEntry.label,
          icon: layoutEntry.icon ?? "salescodeStudioIcon",
          sidebarOptions: allSidebarIds,
        });
      }
    }

    // Handle entirely new navbarParentLabels not in layout config
    const existingDashboardIds = new Set(mainDashboardLayoutConfig.map((e: any) => e.id));

    for (const navbarLabel of allNavbarOptions) {
      if (existingDashboardIds.has(navbarLabel)) continue;

      const sidebarIds = availableSidebarOptions
        .filter(
          (option) =>
            option.navbarParentLabel === navbarLabel &&
            !usedSidebarIds.has(option.id)
        )
        .map((option) => {
          usedSidebarIds.add(option.id);
          return option.id;
        });

      if (sidebarIds.length > 0) {
        dashboardOptions.push({
          id: navbarLabel,
          label: navbarLabel,
          icon: "salescodeStudioIcon",
          sidebarOptions: sidebarIds,
        });
      }
    }
    return dashboardOptions;
  }
    const dashboardLayoutOrder = roleOrderLayout?.find((orderLayoutConfig) => orderLayoutConfig.name === "mainDashboardLayoutOrder")?.value
    if(dashboardLayoutOrder){
        for(let navbarElemObj of dashboardLayoutOrder){
            const sidebarOptions = availableSidebarOptions.filter((sideBarOption) => sideBarOption.navbarParentLabel === navbarElemObj.id).map((sidebarOption) => {
                return sidebarOption.id;
            });
            if(sidebarOptions.length>0){
                const sidebarOrderIndexMap = new Map<string,number>(navbarElemObj.sidebarOptions.map((sidebarOptionId: string, index: number) => [sidebarOptionId, index]));
                sidebarOptions.sort((a: string, b: string) => {
                    const indexA = sidebarOrderIndexMap.get(a);
                    const indexB = sidebarOrderIndexMap.get(b);
                  
                    // If both elements are in the orderArray, sort them based on their order
                    if (indexA !== undefined && indexB !== undefined) {
                      return indexA - indexB;
                    }
                  
                    // If only one of them is in the orderArray, prioritize the one that is
                    if (indexA !== undefined) {
                      return -1;
                    }
                  
                    if (indexB !== undefined) {
                      return 1;
                    }
                    
                    // If neither is in the orderArray, maintain their relative order
                    return 0;
                });
                dashboardOptions.push({
                    id: navbarElemObj.id,
                    label: navbarElemObj.label,
                    icon: "salescodeStudioIcon",
                    sidebarOptions
                })
            }
        }
    }else{
        for(let navbarOption of allNavbarOptions){
            const sidebarOptions = availableSidebarOptions.filter((sideBarOption) => sideBarOption.navbarParentLabel === navbarOption).map((sidebarOption) => {
                return sidebarOption.id;
            });
            if(sidebarOptions.length>0){
                dashboardOptions.push({
                    id: navbarOption,
                    label: navbarOption,
                    icon: "salescodeStudioIcon",
                    sidebarOptions
                })
            }
        }
    }
    
    return dashboardOptions;
}

export function convertToAdminPanelOptions(availableAdminPanelOptions: featureType[],roleOrderLayout?: configurationAttributeType<any[]>[],roleLayoutConfig?:any){
    const adminPanelOptions: adminPanelConfigOptionType[] = [];
     if (!roleLayoutConfig) {
    for(let adminPanelOption of availableAdminPanelOptions){
        const adminPanelRegistryObj = adminPanelOptionConfigRegistry[adminPanelOption.name];
        if(adminPanelRegistryObj){
            adminPanelOptions.push({
                ...adminPanelRegistryObj,
                id: adminPanelOption.name
            } as adminPanelConfigOptionType);
        }
    }
    return adminPanelOptions;
}
const adminPanelLayoutConfig = roleLayoutConfig?.domainValues?.find(
    (config: any) => config.name === "adminPanelLayout"
  )?.value;

  const availableIds = new Set(
    availableAdminPanelOptions.map((option) => option.name)
  );
  const usedIds = new Set<string>();

  if (adminPanelLayoutConfig) {
    for (const layoutEntry of adminPanelLayoutConfig) {
      const id = layoutEntry.id;
      if (availableIds.has(id)) {
        const registryDefaults = adminPanelOptionConfigRegistry[id];
        if (registryDefaults) {
          adminPanelOptions.push({
            ...registryDefaults,
            ...layoutEntry,
            id
          });
          usedIds.add(id);
        }
      }
    }
  }

  for (const adminPanelOption of availableAdminPanelOptions) {
    const id = adminPanelOption.name;
    if (usedIds.has(id)) continue;

    const registryDefaults = adminPanelOptionConfigRegistry[id];
    if (registryDefaults) {
      adminPanelOptions.push({
        ...registryDefaults,
        id
      });
    }
  }
    // const adminLayoutOrder = roleOrderLayout?.find((orderLayoutConfig) => {
    //     return orderLayoutConfig.name === "adminPanelLayoutOrder"
    // })?.value;
    // if(adminLayoutOrder){
    //     const adminOrderIndexMap = new Map(adminLayoutOrder.map((adminObj, index) => [adminObj.id, index]));
    //     adminPanelOptions.sort((a: adminPanelConfigOptionType, b: adminPanelConfigOptionType) => {
    //         const indexA = adminOrderIndexMap.get(a.id);
    //         const indexB = adminOrderIndexMap.get(b.id);

    //         if (indexA !== undefined && indexB !== undefined) {
    //             return indexA - indexB;
    //         }

    //         if (indexA !== undefined) {
    //             return -1;
    //         }

    //         if (indexB !== undefined) {
    //             return 1;
    //         }

    //         return 0;
    //     });
    // }
    return adminPanelOptions;
}

export async function  saveRoleInDB(roleName: string,accessType: "app" | "portal" ) {
    try {
        const response = await ChannelkartNetworkPost("/v1/roles", { name: roleName , extendedAttributes: { accessType } });
        if (!(response.status === 200 || response.status === 201)) throw new Error("something went wrong while saving role in DB")

    } catch (error) {
       if(error instanceof Error){
        throw new Error(error.message);
       }
    }
}
export function getAllAccessibleRoutes(availablePortalOptions: featureType[]){
    const accessibleDashboardRoutes= AllSidebarOptions.filter((sideBarOption) => {
        return availablePortalOptions.find((dashboardOption) => dashboardOption.template==="mainDashboard" && dashboardOption.name === sideBarOption.id);
    }).map((sideBarOption) => sideBarOption.route );
    const accessibleAdminPanelRoutes: string[] = [];
    for(let portalOption of availablePortalOptions){
        if(portalOption.template==="adminPanel"){
            const adminPanelRegistryObj = adminPanelOptionConfigRegistry[portalOption.name];
            if(adminPanelRegistryObj){
                accessibleAdminPanelRoutes.push(adminPanelRegistryObj.route);
            }
        }
    }
    const allAccessibleRoutes = [...accessibleDashboardRoutes,...accessibleAdminPanelRoutes];
    return allAccessibleRoutes;
}
export function convertToUiConfigOrder(uiConfigIds: string[],roleOrderLayout?: configurationAttributeType<any[]>[]){
    const uiConfigLayoutOrder = roleOrderLayout?.find((orderLayoutConfig) => orderLayoutConfig.name === "uiConfigLayoutOrder")?.value;
    if(uiConfigLayoutOrder){
        const uiConfigOrderIndexMap = new Map(uiConfigLayoutOrder.map((uiConfigId, index) => [uiConfigId, index]));
        uiConfigIds.sort((a: string, b: string) => {
            const indexA = uiConfigOrderIndexMap.get(a);
            const indexB = uiConfigOrderIndexMap.get(b);

            if (indexA !== undefined && indexB !== undefined) {
                return indexA - indexB;
            }

            if (indexA !== undefined) {
                return -1;
            }

            if (indexB !== undefined) {
                return 1;
            }

            return 0;
        })

    } 
        
    return uiConfigIds;
}
export function convertToPortalLayout(availablePortalOptions: featureType[],uiConfigIds: string[],roleOrderLayout?: configurationAttributeType<any[]>[],roleLayoutConfig?:any){
    const portalLayout: configurationAttributeType<any[]>[] = [];

    const availableDashboardPortalOptions = availablePortalOptions.filter((portalOption) => {
      return portalOption.template === "mainDashboard";
    })
    const dashboardOptions = convertToDashboardOptions(availableDashboardPortalOptions,roleOrderLayout,roleLayoutConfig);
    portalLayout.push({
      "name": 'mainDashboardLayout',
      "type": "list",
      "value": dashboardOptions, 
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "dashboard Config",
      "possibleVals": [],
    });
    const availableAdminPanelOptions = availablePortalOptions.filter((portalOption) => {
      return portalOption.template === "adminPanel";
    })
    const adminPanelLayoutOptions = convertToAdminPanelOptions(availableAdminPanelOptions,roleOrderLayout,roleLayoutConfig);
    portalLayout.push({
      "name": 'adminPanelLayout',
      "type": "list",
      "value": adminPanelLayoutOptions,
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "Admin Panel Config",
      "possibleVals": [],
    });
    const uiConfigLayout = convertToUiConfigOrder([...uiConfigIds],roleOrderLayout);
    portalLayout.push({
      "name": 'uiConfigLayout',
      "type": "list",
      "value": uiConfigLayout,
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "UI Config Features",
      "possibleVals": [],
    })
    return portalLayout;
  }

export async function getLobListFromEnv(env:string):Promise<string[]>{
    try{
        const hckeckDataResponse = await envGetRequest(env, '/hckeck')
        return hckeckDataResponse.data.systemInfo.lobNames;
    }catch(error){
        console.log(error)
        return []
    }
}

export async function fetchConfigToImport(env:string,lob:string){
    const importedConfig = await envGetRequest(env,'/metadata/clientconfig', {lob})
    return importedConfig
}


export const overWriteConfig = async (configsToImport:MetaDataConfigObject[], keysToImport:{[key in newConfigurationNames]?:string[] | "importAll"})=>{
    const clientConfig:MetaDataConfigObject[] = await getMetaDataConfig("clientconfig");

    const updatedConfigs:MetaDataConfigObject[] = configsToImport.map(configObject=>{
        const prevConfig = clientConfig.find(config=>config.domainName === configObject.domainName && config.domainType === configObject.domainType);
        if(keysToImport[configObject.domainType] === "importAll" ){
            return configObject;
        }
        const configsToImport = keysToImport[configObject.domainType] as string[] ?? [];
        const filteredImportConfig = prevConfig ? prevConfig.domainValues.filter(config=>!configsToImport.includes(config.name)) : [];
        configsToImport.forEach(configName=>{
            const configToInclude = configObject.domainValues.find(config=>config.name === configName);
            if(configToInclude){
                filteredImportConfig.push(configToInclude);
            }
        })
        return {
            ...configObject,
            domainValues:filteredImportConfig
        }
    })
    return updatedConfigs;
}

function isPlaygroundConfig(domainName: string, domainType: string): boolean {
    return domainName === "clientconfig" && domainType === "playground_config";
}

export async function doFinalConfigSubmit(configName: newConfigurationNames, convertedVals: any[],curConfigRef?: React.MutableRefObject<{ [key: string]: any[]; }>,domainName?: string,accessType?: "admin" | "all"):Promise<boolean>{
    const configDataPayload: updateConfigRequestBody = {
        domainName: domainName ?? "clientconfig",
        domainType: configName,
        domainValues: convertedVals,
        lob: getLob(),
    };  
    const finalMetaDataPayload: metaDataBatchPayload = { features: [configDataPayload] };
    const isPlaygroundConfigData = isPlaygroundConfig(domainName ?? "clientconfig", configName);
    if (isPlaygroundConfigData) {
        try {
            return ChannelkartNetworkPut(META_DATA_PLAYGROUND_API, finalMetaDataPayload);
        } catch (e) {
            return false;
        }
    }

    return new Promise((resolve, reject) => { validateWithOtp(async (verifiedUser?: manageUpdateAccessObj,verifyResponse?: any)=>{
        try{
            if(verifyResponse.status >= 200 || verifyResponse.status < 300){
                const validationObj = validateMetaDataResponse(verifyResponse?.data?.features);
                sendConfigAnalyticsEvent("config_updated",finalMetaDataPayload,verifyResponse,"Kpi-dashboard: uiConfig",verifiedUser)
                if(validationObj.success){
                    if(curConfigRef) curConfigRef.current[configName] = convertedVals; //setting curConfig to newConfigValues on success for configComparePopup
                    resolve(true);
                    if(!domainName) openPopup("Success","Configuration Updated")
                }else{
                    reject(new Error(validationObj.message));
                }
            }
            else 
                reject(new Error("Error occured while updating configuration"))
        }catch(err){
            // Sentry.captureException(err);
            if(err instanceof Error)
                openPopup("Error",err?.message)
        }
    },["demo","prod","prod-egtm"],accessType ?? "admin",META_DATA_BATCH_API,finalMetaDataPayload,"PUT")});
  }
export function validateMetaDataResponse(metaDataResp: any[]){
    for(let idx = 0;idx<metaDataResp.length;idx++){
        const idxMetaResp = metaDataResp[idx];
        if(idxMetaResp.status && idxMetaResp?.status?.toLowerCase()!=="success"){
            return { success: false, message: idxMetaResp?.validation?.violations?.[0]?.message ?? "Something went wrong while updating metaData"};
        }
    }
    return { success: true, message: "MetaData submitted Successfuly"}
}

export const fetchSaleLensConfig = async (clientConfigRef?:any) => {
    const currentUserData = JSON.parse(localStorage.getItem("authContext") ?? "{}")?.user;
    let clientConfig:any
    if(clientConfigRef && clientConfigRef.length>0){
        clientConfig = clientConfigRef
    }else{
        clientConfig = await getMetaDataConfig("clientconfig");
    }
    const roleBasedAccess = isRoleConfigEnabled(clientConfig);
    let roles = getUserRolesBasedOnAccess(roleBasedAccess,currentUserData);
    const designations = currentUserData?.designation ?? [];
    if(!designations.includes("admin")){
      const curUserRole = roles[0];
      const configName = `${curUserRole}_salesLens_configuration`;
      const portalConfig = clientConfig?.find((config: { domainType: string }) => {
        return config.domainType === configName;
      })?.domainValues;
      const onlySaleslens = portalConfig && portalConfig?.find((item: { name: string; }) => item.name === "redirectSaleslens")?.value
      return onlySaleslens
    }
  }

export const fetchPricingAtLogin = async (clientConfigRef?:any): Promise<boolean> => {
    let clientConfig:any
    if(clientConfigRef && clientConfigRef.length>0){
        clientConfig = clientConfigRef
    }else{
        clientConfig = await getMetaDataConfig("clientconfig");
    }
    const portalConfig = clientConfig?.find((config: { domainType: string }) => {
      return config.domainType === "portal_configuration";
    })?.domainValues;
      const dms = portalConfig && portalConfig?.find((item: { name: string; }) => item.name === "disablePricingFetchAtLogin")?.value
      if(dms){
        return !(dms as boolean);
      }else{
        return true;
      }
}

  export const fetchDMSConfig = async (clientConfigRef?:any) => {
    let clientConfig:any
    if(clientConfigRef && clientConfigRef.length>0){
        clientConfig = clientConfigRef
    }else{
        clientConfig = await getMetaDataConfig("clientconfig");
    }
    const portalConfig = clientConfig?.find((config: { domainType: string }) => {
      return config.domainType === "portal_configuration";
    })?.domainValues;
      const dms = portalConfig && portalConfig?.find((item: { name: string; }) => item.name === "dms")?.value
      if(dms){
        return dms;
      }else{
        return false;
      }
  }

  export const fetchPortalClientConfig = async (clientConfigRef?:any) => {
    let clientConfig:any
    if(clientConfigRef && clientConfigRef.length>0){
        clientConfig = clientConfigRef
    }else{
        clientConfig = await getMetaDataConfig("clientconfig");
    }
    const portalConfig = clientConfig?.find((config: { domainType: string }) => {
      return config.domainType === "portal_configuration";
    })?.domainValues;
      const fetchClientConfig = portalConfig && portalConfig?.find((item: { name: string; }) => item.name === "fetchClientConfig")?.value
      if(fetchClientConfig){
        return fetchClientConfig;
      }else{
        return false;
      }
  }
  

export const getSalesLensUrl = async () => {
    try {
        const currentUrl = window.location.href;
        const url = new URL(currentUrl);
        const baseUrl = `${url.protocol}//${url.host}/logOff`;
    //   if (window.location.hostname.includes("salescode.ai")) {
    //     await setDashboardCookies();
    //     return `https://saleslens.salescode.ai/dashboard?logOutUrl=${baseUrl}`;
    //   } else {
        const token = getAccessToken() ?? "";
        const resp = await axios.get("https://saleslens.salescode.ai/dashboard/session", {
          headers: {
            Authorization: token
          }
        });
        if (resp.status >= 200 && resp.status < 300) {
          const salesLensUrl = resp?.data?.url;
          return salesLensUrl+`?logOutUrl=${baseUrl}`;
        } else {
          console.error("Failed to fetch SalesLens URL, status code:", resp.status);
          openPopup("Error", "Error fetching SalesLens URL");
          await logoutUser();
          return null;
        }
    //   }
    } catch (error) {
      console.error("Error fetching SalesLens URL:", error);
      openPopup("Error", "Error fetching SalesLens URL");
      await logoutUser();
      return null; 
    }
  };
export const fetchEndToEndConfig = async (clientConfigRef?: any) => {
    
    const lob = localStorage.getItem("lob")
        ? undefined
        : getLob();
    const clientConfig = await getLOBClientConfig(lob);
    const endToend = clientConfig?.find((config: { domainType: string }) => config.domainType === "config")?.domainValues?.[0]?.["endToEndEncryptionEnabled"];
    
    if (endToend) {
        return true;
    } else {
        return endToend;
    }
}
  export const transformConfigData = <T extends Record<string, any>>(
    data: Record<string, T>,
    domainType: string
  ): TransformedConfig => {
    return Object.entries(data).reduce((acc, [key, value]) => {
      acc[key] = {
        name: key,
        type: value.type,
        value: value.value,
        docUrl: value.docUrl,
        description: value.description,
        domainType,
        possibleVals: value.possibleVals,
      };
      return acc;
    }, {} as TransformedConfig);
  };
  export const fetchUIConfigData = async (setValues:any,setDefaultConfig:any,configName:string,setLoading?:any) => {
    try {
      const response = await ChannelkartNetworkGet(
        `${UI_CONFIG_API_BASE_URL}/${configName}`
      );
      if (response?.status === 200) {
        const transformedData = transformConfigData(response.data[configName], configName);
        setValues(transformedData)
        setDefaultConfig(transformedData)
        if (setLoading) {
          setLoading(false);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      if (setLoading) {
        setLoading(false);
      }
    }
  };
export const fetchMultipleUIConfigData = async (setValues: any, setDefaultConfig: any, configNames: string[], setLoading?: any) => {
    try {
        const allConfigs = await Promise.all(configNames.map(async (configName) => {
            const response = await ChannelkartNetworkGet(`${UI_CONFIG_API_BASE_URL}/${configName}`);
            if (response?.status === 200) {
                return transformConfigData(response.data[configName], configName);
            }
            return {};
        }));

        const mergedConfig = allConfigs.reduce((acc: any, config: any) => {
            return { ...acc, ...config };
        }, {});

        setValues(mergedConfig);
        setDefaultConfig(mergedConfig);
        if (setLoading) {
            setLoading(false);
        }
    } catch (error) {
        console.error("Error fetching data:", error);
        if (setLoading) {
            setLoading(false);
        }
    }
};
  export const UI_CONFIG_API_BASE_URL = "https://l8oq52vga7.execute-api.ap-south-1.amazonaws.com/globalConfig";

export const setAppAndRoleOptions = ({
    setAppTypeOptions,
    setRoleOptions,
    clientConfig,
    savedRole
}: {
    setAppTypeOptions: (options: AppOptionType[]) => void;
    setRoleOptions: (options: OptionType[]) => void;
    clientConfig: any;
    savedRole: any;
}) => {
    const valueToReturn = {
      "appType" : null,
      "role" : null,
    }
    const portal_configuration = getConfigFromClientConfig(clientConfig,"portal_configuration");
    const appTypeAndDesignationInfo = portal_configuration?.find((option: {name: string}) => {
        return option.name === "appTypeAndDesignationInfo"
    })
    const rolesPresentConfig = portal_configuration?.find((option: {name: string}) => {
        return option.name === "rolesPresent"
    }); 

    // if appTypeAndDesignation info is presne tthen its okay 
    // if its absent then user the roesPresentConfig , setAppTypeOptions as {id: "sfa" , "label": "SFA"}, and setRoleOptions as rolesPresentConfig.value
    // if rolesPresentConfig is absen then setAppTypeOptions as {id: "sfa" , "label": "SFA"}, and setRoleOptions as {id: "retailer" , "label": "Retailer"}
    if(appTypeAndDesignationInfo && Array.isArray(appTypeAndDesignationInfo.value)){
        setAppTypeOptions(appTypeAndDesignationInfo.value);
        if(appTypeAndDesignationInfo.value.length>0){
            setCurrentAppType(appTypeAndDesignationInfo.value[0]);
            valueToReturn.appType = appTypeAndDesignationInfo.value[0];
            const rolesPresent = appTypeAndDesignationInfo.value[0].designations;
            if(rolesPresent && Array.isArray(rolesPresent)){
                if(rolesPresent.length > 0){
                    setRoleOptions(rolesPresent);
                    // only change role if it is not the same as the saved role
                    if(rolesPresent[0]?.id !== savedRole?.id){
                      setCurrentRole(rolesPresent[0]);
                    }
                    valueToReturn.role = rolesPresent[0];
                }
            }
        }
        return valueToReturn;
    }else{
        setAppTypeOptions([{id: "sfa", label: "SFA", designations: rolesPresentConfig?.value ?? [{id: "retailer", label: "Retailer"}]}]);
        setRoleOptions(rolesPresentConfig?.value ?? [{id: "retailer", label: "Retailer"}]);
        setCurrentAppType("sfa");
        setCurrentRole(rolesPresentConfig?.value?.[0] ?? {id: "retailer", label: "Retailer"});
        return {
          appType: {id: "sfa", label: "SFA", designations: rolesPresentConfig?.value ?? [{id: "retailer", label: "Retailer"}]},
          role: rolesPresentConfig?.value?.[0] ?? {id: "retailer", label: "Retailer"}
        }
    }
}
 export const appendInTileOptions = (
   index: number,
   domainObj: any,
   domainType: string,
   configMapping: any,
   customHandlerConfig: any
 ) => {
  if(index < 0 || index >= configMapping[domainType].length) return;
   const customValuesToAdd = customHandlerConfig?.customValue ?? [];
   const existingValues = configMapping?.[domainType]?.[index]?.value || [];

   configMapping[domainType][index].value = [
     ...existingValues,
     ...customValuesToAdd,
   ];
 };

 export const removeFromTileOptions = (
   index: number,
   domainObj: any,
   domainType: string,
   configMapping: any,
   customHandlerConfig: any
 ) => {
   const { customValue = [], identificationField } = customHandlerConfig ?? {};
   const existingValues = configMapping?.[domainType]?.[index]?.value || [];

   configMapping[domainType][index].value = existingValues.filter(
     (item: any) => !customValue.includes(item[identificationField])
   );
 };

 export const updateTabList = (
   index: number,
   domainObj: any,
   domainType: string,
   configMapping: any,
   customHandlerConfig: any
 ) => {
   const identificationField = customHandlerConfig.identificationField;
   const name = domainObj.name;
   const newTabs: any[] = domainObj.value;

   const existingTabsConfig = configMapping[domainType][index];

   let updatedTabs: any[] = [];

   if (existingTabsConfig) {
     // Remove old tabs that are being replaced
     updatedTabs = [
       ...existingTabsConfig.value.filter(
         (existingTab: any) =>
           !newTabs.some(
             (newTab: any) =>
               newTab[identificationField] === existingTab[identificationField]
           )
       ),
       ...newTabs,
     ];

     // Ensure special tabs remain at the end
     const specialTabs = ["Change Password", "Logout"];
     const extractedTabs = updatedTabs.filter((tab) =>
       specialTabs.includes(tab[identificationField])
     );
     updatedTabs = updatedTabs.filter(
       (tab) => !specialTabs.includes(tab[identificationField])
     );

     updatedTabs.push(...extractedTabs);

     existingTabsConfig.value = updatedTabs;
   } else {
     // If entry doesn't exist (shouldn't usually happen if index is passed correctly)
     configMapping[domainType].push({
       name: name,
       value: newTabs,
     });
   }
 };

 export const removeTab = (
   index: number,
   domainObj: any,
   domainType: string,
   configMapping: any,
   customHandlerConfig: any
 ) => {
   const identificationField = customHandlerConfig.identificationField;
   const currentTabs = configMapping[domainType][index].value;

   // We assume domainObj.value is an array of tabs to remove (typically one tab).
   const tabsToRemove = domainObj.value;

   // Filter out all tabs that match the identificationField of any tab in tabsToRemove
   const updatedTabs = currentTabs.filter(
     (tab: any) =>
       !tabsToRemove.some(
         (tabToRemove: any) =>
           tab[identificationField] === tabToRemove[identificationField]
       )
   );

   // Update the config mapping
   configMapping[domainType][index].value = updatedTabs;
 };

 export const domainValueHandlers: {
   [key: string]: (
     index: number,
     domainObj: any,
     domainType: string,
     configMapping: any,
     customHandlerObj: any
   ) => void;
 } = {
   updateTabList,
   removeTab,
   appendInTileOptions,
   removeFromTileOptions,
 };
// returns a map of domainType ( since it can be possible for a feature to need both clientConfig and passwordConfig )
// each domainName is mapped to its unique override order ( since we only need global->default->app->role in client config , but for password config we need to just give the config as it is , thus createing a map )
export const getStudioConfigMap = async (
  domainNamesAndTypeMap: Record<string,string[]>, 
  overrideOrder: Record<string,string[]> = 
    {
      "clientconfig":
        [
          "globalConfig",
          "defaultConfig",
          "appTypeConfig",
          "roleSpecificConfig",
        ]
    }
) => {
    // we will itereate over the ovverideOrder and make sure to pass the same format as the configMaps , and then we can have custom config overide function for each override step and in each override step we can treat each domainName differenty , since thats how it should be done 
  // iterate over the domainNames and for each domainName call its getStudioConfigMap funciton , and pass the overrideOrder if present to it 
  const configMap: Record<string, any> = {};
  for(const domainName of Object.keys(domainNamesAndTypeMap)){
    const overrideOrderForDomain = overrideOrder[domainName] ?? [];
    switch(domainName){
      case 'clientconfig':
        configMap[domainName] = await getInitialClientConfig(overrideOrderForDomain,domainNamesAndTypeMap[domainName]) ?? [];
        break;
      default:
        configMap[domainName] = await getInitialConfigByDomainName(domainName) ?? [];
        break;
    }    
  }
  // update the config map ( itetate over each domainName > domainObjs > domainValues ? domainValueObj , if that object doenst have the key "name" then add the key and give the value "temporary_{tempIndex}" to it , and then i can just remove this key by checking ("name" contains "temporary_" while saving the config ))
  const updatedConfigMap = ensureAllConfigObjHasNameKey(configMap);
  return updatedConfigMap;
}
const tempNameKeyPrefix = "temporary_";
const ensureAllConfigObjHasNameKey = (configMap: Record<string, any>) => {
  let tempIndex = 0;
  for(const domainName of Object.keys(configMap)){
    for(const domainObj of configMap[domainName]){
      for(const domainValueObj of domainObj.domainValues){
        if(!domainValueObj.name){
          domainValueObj.name = `${tempNameKeyPrefix}${tempIndex}`;
          tempIndex++;
          console.log("domainValueObj",domainValueObj);
        }
      }
    }
  }
  console.log("no of temp index",tempIndex);
  return configMap;
}
const removeTemporaryNameKeyFromConfigMap = (configMap: Record<string, any>) => {
  for(const domainName of Object.keys(configMap)){
    for(const domainObj of configMap[domainName]){
      for(const domainValueObj of domainObj.domainValues){
        if(domainValueObj?.name?.includes(tempNameKeyPrefix)){
          delete domainValueObj.name;
        }
      }
    }
  }
  return configMap;
}
const getInitialClientConfig = async (overrideOrder?: string[],domainTypes: string[] = []) => {
  const domainName = "clientconfig"
  // if ovverideOrder is empty , then just return the clientConfig 
  let clientConfig : any;
  if(!overrideOrder || overrideOrder?.length === 0){
    clientConfig = await getMetaDataConfig(domainName);
    return clientConfig;
  }
  // this map contains overideId to its corresponding function 
  const overrideIdToFunctionMap: Record<string, (config: any,domainTypes: string[]) => any> = {
    "globalConfig": getInitialGlobalConfig_ClientConfig,
    "defaultConfig": getInitialDefaultConfig_ClientConfig,
    "appTypeConfig": getInitialAppTypeConfig_ClientConfig,
    "roleSpecificConfig": getInitialRoleSpecificConfig_ClientConfig,
  }

  for(const overrideId of overrideOrder){
    clientConfig = await overrideIdToFunctionMap[overrideId](clientConfig,domainTypes) ?? [];
  }


  return removeDuplicateDomainEntries(clientConfig)
}

function removeDuplicateDomainEntries(config: any[]) {
  const seen = new Set();
  return config.filter(item => {
    const key = `${item.domainName}_${item.domainType}`;
    if (seen.has(key)) {
      return false; 
    }
    seen.add(key);
    return true;
  });
}


/* 
  * get the global config and return the required domainTypes objects 
  * example domainType : ["password_configuration"]
  * then we will return a [{domainType: "password_configuration", domainValues: [.. domain values inside global config for "password_configuration"]}]
*/
const getInitialGlobalConfig_ClientConfig = async (inputConfig: any, domainTypes: string[]) : Promise<any> => {
  const domainName = "clientconfig"
  const config = await getGlobalConfig(domainName);
  const filteredConfigs = config?.filter((config: any) => domainTypes.includes(config.domainType)) ?? [];
  removeDuplicateDomainValuesAndTypes(filteredConfigs);
  return filteredConfigs;
} 
/*
  * get the default config and return the required domainTypes objects , override the globalConfig (inputConfig) if those specific domainTypes exists inside it
  * example domainType : ["password_configuration"]
  * then we will return the following objects of the clientConfig => ["password_configuration",${role}_specific_config , ${app_type}_app_configuration,portal_configuration , ${role}_password_configuration]
  * if some of the above mention domainType existed in the global config , then we just override the domainValues of the domainObj which exists in both and add those objects which exists in global but not in default config 
*/
const getInitialDefaultConfig_ClientConfig = async (inputConfig: any,domainTypes: string[]): Promise<any> => {
  const domainName = "clientconfig";
  const fetchedConfig = await getMetaDataConfig(domainName); // assumed to be an array
  const requiredConfigs = filterOutRequiredConfigs(fetchedConfig,domainTypes);
  let finalConfig: any[] = [...requiredConfigs ?? []];

  if (inputConfig) {
    for (const domainObj of inputConfig) {
      const domainType = domainObj.domainType;
      const existingConfig = requiredConfigs.find((config: any) => config.domainType === domainType);

      if (!existingConfig) {
        // If domainType doesn't exist in fetched config, push the whole domainObj
        finalConfig.push(domainObj);
      } else {
        const domainValues = domainObj.domainValues ?? [];
        const existingDomainValues = existingConfig.domainValues ?? [];

        for (const domainValue of domainValues) {
          const alreadyExists = existingDomainValues.some(
            (val: any) => val.name === domainValue.name
          );
          if (!alreadyExists) {
            existingDomainValues.push(domainValue);
          }
          else{
              domainValue.value=existingDomainValues.find(
              (val: any) => val.name === domainValue.name
            ).value;
          }
        }
        // Update domainValues and push updated config]
        existingConfig.domainValues = existingDomainValues;
        // find the index of the existingConfig in finalConfig and replace it with the updated config
        const index = finalConfig.findIndex((config: any) => config.domainType === domainType);
        finalConfig[index] = existingConfig;
      }
    }
  }
  removeDuplicateDomainValuesAndTypes(finalConfig);
  return finalConfig;
};

const getInitialAppTypeConfig_ClientConfig = async (inputConfig: any,domainTypes: string[]) : Promise<any> => {
  // rn handling for current flow only ( i.e defualtConfig -> appType config) 
  const portal_configuration = getConfigFromClientConfig(inputConfig,"portal_configuration");
  const appTypeAndDesignationInfo = portal_configuration?.find((option: {name: string}) => {
      return option.name === "appTypeAndDesignationInfo"
  })?.value ?? [];
  if(appTypeAndDesignationInfo.length === 0){
    return inputConfig;
  }
  const appTypes = appTypeAndDesignationInfo.map((appType: AppOptionType) => appType.id);
  // app_configuration will get overrideen by appType_app_configuration 

  const defaultAppTypeConfig = inputConfig.find((config: any) => config.domainType === "app_configuration");

  const appTypeConfigs = appTypes.map((appType: string)=>{
    // if appTYpe_app_configuration existst then iterate over the domainValues and merge them with the defaultAppTypeConfig
    // if it doenst existst then create one and merge the domainValues with the defaultAppTypeConfig
    // default have less priuority than appType_app_configuration
    let appTypeConfig = inputConfig.find((config: any) => config.domainType === `${appType}_app_configuration`);
    if(appTypeConfig){
      const newDomainValues = [...appTypeConfig.domainValues]; // high prioirty 
      for(const domainValue of defaultAppTypeConfig.domainValues){ // low priority , if some doenst exists then we take the low prioirty one 
        const alreadyExists = appTypeConfig.domainValues.find((val: any) => val.name === domainValue.name);
        if(!alreadyExists){
          newDomainValues.push(domainValue);
        }
      }
      appTypeConfig.domainValues = newDomainValues;
      return appTypeConfig;
    }
    else{

      appTypeConfig = {
        domainType: `${appType}_app_configuration`,
        domainValues: defaultAppTypeConfig.domainValues,
        domainName: "clientconfig"
      }
    }
    return appTypeConfig;
  })



  /**
   * Processes a list of appTypeConfigs and merges them into the initialConfig.
   * 
   * For each valid appTypeConfig:
   * 1. Extracts the appType and its associated designations.
   * 2. Groups domain values by their domainType.
   * 3. Creates designation-specific domainTypes (e.g., Manager_Claims).
   * 4. Merges these into initialConfig:
   *    - If the domainType exists, merges and overrides matching domainValues.
   *    - Otherwise, adds a new config entry.
   * 
   * This ensures initialConfig contains designation-scoped domainType entries
   * with properly mapped domain values.
 */

  for (const appTypeConfig of appTypeConfigs) {
    if (appTypeConfig == null || Object.keys(appTypeConfig).length === 0) continue;
  
    const appTypeOfTheConfig = appTypeConfig.domainType.split('_')[0];
    const designationForTheAppType = appTypeAndDesignationInfo.find((obj: any) => obj.id === appTypeOfTheConfig)?.designations ?? [];
    const domainTypeAndValueMap: Record<string, any> = {};
    const domainValues = appTypeConfig.domainValues ?? [];
  
    if (domainValues.length === 0 || designationForTheAppType.length === 0) continue;
  
    for (const domainValue of domainValues) {
      const domainType = domainValue.domainType;
      if(!domainType) continue;
      if (!domainTypeAndValueMap[domainType]) {
        domainTypeAndValueMap[domainType] = [];
      }
      domainTypeAndValueMap[domainType].push({
        name: domainValue["name"],
        value: domainValue["value"],
        type: domainValue["type"]
      });
    }
    const designationViseConfigMap: Record<string, any> = {};
  
    for (const designationObj of designationForTheAppType) {
      const designation = designationObj.id;
      const allRequiredDomainTypes: string[] = Array.from(
        new Set([...Object.keys(domainTypeAndValueMap), ...domainTypes])
      );      
      for (const domainType of allRequiredDomainTypes) {
        const newDomainType = `${designation}_${domainType}`;


        // this have more prioity 
        const existingValues = domainTypeAndValueMap[domainType] ?? [];
        // this is fallback values 
          const domainValues = inputConfig.find((obj: any) => obj.domainType === domainType)?.domainValues ?? [];
       // this is the merge of inputconfig over exissting value 
          const newDoaminvalues = existingValues;
        for (const domainValue of domainValues) {
            // already have a high priority object 
          const alreadyExists = existingValues.find(
            (val: any) => val.name === domainValue.name
          );
            
          if (!alreadyExists) {
              // if high priority dont then we take the fallback 
            // existingValues.push(domainValue);

              newDoaminvalues.push(domainValues.find(
              (val: any) => val.name === domainValue.name
            ));
          }
        }
        designationViseConfigMap[newDomainType] = newDoaminvalues;
      }
    }
  
    for (const domainType of Object.keys(designationViseConfigMap)) {
      if(!domainType) continue;
      const existingConfig = inputConfig.find((obj: any) => obj.domainType === domainType);
      const domainValues = designationViseConfigMap[domainType] ?? [];
  
      if (existingConfig) {
        const newDomainValues = [...domainValues];
  
        for (const domainObj of existingConfig.domainValues ?? []) {
          const existsInAppTypeConfig = domainValues.find((obj: any) => obj.name === domainObj.name);
          if (existsInAppTypeConfig) {
            newDomainValues.push({ ...domainObj, value: existsInAppTypeConfig.value });
          }
        }
  
        inputConfig.push({ ...existingConfig, domainValues: newDomainValues });
      } else {
        inputConfig.push({
          domainType: domainType,
          domainValues: domainValues,
          domainName: "clientconfig"
        });
      }
    }
  }
  removeDuplicateDomainValuesAndTypes(inputConfig);
  return inputConfig
}
const getInitialRoleSpecificConfig_ClientConfig = async (inputConfig: any,domainTypes: string[]): Promise<any> => {
  if (!Array.isArray(inputConfig)) return inputConfig;

  const portal_configuration = getConfigFromClientConfig(inputConfig, "portal_configuration");
  const appTypeAndDesignationInfo = portal_configuration?.find((option: { name: string }) => {
    return option?.name === "appTypeAndDesignationInfo";
  })?.value ?? [];

  if (!Array.isArray(appTypeAndDesignationInfo) || appTypeAndDesignationInfo.length === 0) {
    return inputConfig;
  }

  const rolesPresent = appTypeAndDesignationInfo
    .map((appType: any) => Array.isArray(appType?.designations) ? [...(appType.designations?.map((role: OptionType) => role.id))] : [])
    .flat()
    .filter((role) => typeof role === "string");

  const roleSpecificConfigs = rolesPresent.map((role: string) => {
    return inputConfig.find((config: any) => config?.domainType === `${role}_specific_configuration`);
  });

  for (const roleSpecficConfig of roleSpecificConfigs) {
    if (!roleSpecficConfig || !Array.isArray(roleSpecficConfig.domainValues)) continue;

    const domainTypeToValueMap: Record<string, any> = {};
    const domainValues = roleSpecficConfig.domainValues ?? [];
    const role = roleSpecficConfig.domainType?.split('_')?.[0];
    if (!role) continue;

    for (const domainValue of domainValues) {
      if (!domainValue?.domainType || domainValue?.name == null) continue;

      const domainType = domainValue.domainType;
      if (!domainTypeToValueMap[domainType]) {
        domainTypeToValueMap[domainType] = [];
      }
      //high priority
      domainTypeToValueMap[domainType].push({
        name: domainValue.name,
        value: domainValue.value,
        type: domainValue.type
      });
    }
    

    for (const domainType of Object.keys(domainTypeToValueMap)) {
      //low priority
      const existingConfig = inputConfig.find((config: any) => config?.domainType === `${role}_${domainType}`);
      const newDomainValues: any[] = [];

      if (existingConfig?.domainValues) {
        //low priority
        const existingDomainValues = existingConfig.domainValues;
        for (const domainValue of domainTypeToValueMap[domainType]) {
          const existsInExistingConfig = existingDomainValues.find((obj: any) => obj?.name === domainValue.name);
          if (existsInExistingConfig) {
             newDomainValues.push(domainValue);
          } else {
            newDomainValues.push(domainValue);
          }
        }
      } else {
        newDomainValues.push(...domainTypeToValueMap[domainType]);
      }

      inputConfig.push({
        domainType: `${role}_${domainType}`,
        domainValues: newDomainValues,
        domainName: "clientconfig"
      });
    }
  }
  removeDuplicateDomainValuesAndTypes(inputConfig);
  return inputConfig;
};
const removeDuplicateDomainValuesAndTypes = (inputConfig: any[]) => {
  const uniqueDomainTypeMap = new Map();

  for (const domainObj of inputConfig) {
    const domainType = domainObj.domainType;

    // If we've already seen this domainType, skip it
    if (uniqueDomainTypeMap.has(domainType)) {
      const existingDomainObj = uniqueDomainTypeMap.get(domainType);
      const existingValues = existingDomainObj.domainValues ?? [];
      const newValues = domainObj.domainValues ?? [];
      for (const val of newValues) {
        const existingIndex = existingValues.findIndex((e: any) => e.name === val.name);

        if (existingIndex !== -1) {
          const existingVal = existingValues[existingIndex];

          if (existingVal.value !== val.value) {
            existingValues[existingIndex] = { ...existingVal, value: val.value };
          }
        } else {
          existingValues.push(val);
        }
      }

      existingDomainObj.domainValues = existingValues;
    }

    // Remove duplicate values based on val.name
    if (Array.isArray(domainObj.domainValues)) {
      const seenNames = new Set();
      const filteredValues = [];

      for (const val of domainObj.domainValues) {
        if (!seenNames.has(val.name)) {
          seenNames.add(val.name);
          filteredValues.push(val);
        }
      }

      domainObj.domainValues = filteredValues;
    }

    // Store the cleaned domainObj under its domainType
    uniqueDomainTypeMap.set(domainType, domainObj);
  }

  // Replace original array with the unique values
  return Array.from(uniqueDomainTypeMap.values());
};

// get the config by domainName and return them as it is ; ( this works as a default case when we have no override logic implemented)
const getInitialConfigByDomainName = async (domainName: string) : Promise<any> => {
  const config = await getMetaDataConfig(domainName) ?? [];
  return config;
}
const getTransformedGlobalConfig = (response: any , domainName: string) => {
  const inputConfig = response ?? {};
  const finalConfig = [];
  for (const domainType of Object.keys(inputConfig)) {
    const configItem = inputConfig[domainType];
    let allDomainValuesList = [];
    for (const domainValName of Object.keys(configItem)) {
      const domainVal = configItem[domainValName];
      const obj = {
        name: domainValName ,
        type: domainVal.type,
        value: domainVal.value ?? null,
        docUrl: domainVal.docUrl,
        description: domainVal.description,
        possibleVals: domainVal.possibleVals,
      };

      allDomainValuesList.push(obj);
    }
    const domainTypeObject = {
      domainType : domainType,
      domainValues : allDomainValuesList,
      domainName : domainName,
    }
    finalConfig.push(domainTypeObject)
  }
  return finalConfig;
}
const  getGlobalConfig = async (domainName: string) => {
  // rightnow the global config is only made for domainName = clientconfig , so the parameter domainName is unnecessary
  const response = await ChannelkartNetworkGet(
    `${UI_CONFIG_API_BASE_URL}`
  );
  if (response?.status === 200) {
    const transformedData = getTransformedGlobalConfig(response.data , domainName);
    return transformedData;
  }
  return null;
}


const filterOutRequiredConfigs = (config: any[], domainTypes: string[]) => {
  // Filters configs to keep:
  // - Exact matches with domainTypes
  // - Ends with "app_configuration" or "specific_configuration"
  // - Ends with any of the domainTypes (like *_password_configuration)

  return config?.filter((cfg) => {
    const domainType = cfg.domainType;

    if (domainTypes.includes(domainType)) return true;

    if (
      domainType.endsWith("app_configuration") ||
      domainType.endsWith("specific_configuration") || 
      domainType.endsWith("portal_configuration")
    ) return true;

    if (domainTypes.some((dt) => domainType.endsWith(`_${dt}`))) return true;

    return false;
  });
};

// @prams !
// get a map of domainName : value ( since there can be clientconfig , passwordconfig , etc , anything is possible )
// get global config 
const getMetaDataPayloadForFeatureSelectionMutlipleRoles = (
  requiredConfigsList: string[],
  updatedConfigList: Record<string, any>[],
  selectedRoles: OptionType[],
) => {
  const requiredDomainTypesConfig = updatedConfigList.filter((obj: Record<string, any>) => requiredConfigsList.includes(obj.domainType));
  const requiredDomainTypesWithoutDesignationPrefix = removeDesignationPrefix(requiredDomainTypesConfig,selectedRoles);
  const lob = getLob();
  const finalPayload: any = [];
  for(const selectedRole of selectedRoles){
    for(const domainObj of requiredDomainTypesWithoutDesignationPrefix){
      const payLoadObj = {
        domainName: "clientconfig",
        domainType: `${selectedRole.id}_${domainObj["domainType"]}`,
        domainValues: domainObj["domainValues"],
        lob: lob,
      }
      finalPayload.push(payLoadObj);
    }
  }
  return finalPayload;
}


export const saveStudioConfig = async (
  intialSelectedRole: OptionType,
  selectedAppType: AppOptionType,
  selectedRoles: OptionType[],
  requiredConfigsMap: Record<string, any>,
  initialConfigMap: Record<string, any>,
  updatedConfigMap: Record<string, any>,
  affectAppTypeSpecificConfig: boolean = false,
  featureSelectionFlag: boolean = false,
  actionPostSuccess: () => void
) => {
  const apiType = "PUT";
  const initialConfigMapWithoutTempNameKey = removeTemporaryNameKeyFromConfigMap(initialConfigMap);
  const updatedConfigMapWithoutTempNameKey = removeTemporaryNameKeyFromConfigMap(updatedConfigMap);
  let finalPayload: any = [];
  if(featureSelectionFlag){
    finalPayload = getMetaDataPayloadForFeatureSelectionMutlipleRoles(
      requiredConfigsMap["clientconfig"],
      updatedConfigMap["clientconfig"],
      selectedRoles,
    );
  }
  else{
    finalPayload = getFinalMetaDataPayload(
      intialSelectedRole,
      requiredConfigsMap,
      updatedConfigMapWithoutTempNameKey,
      initialConfigMapWithoutTempNameKey,
      selectedAppType,
      selectedRoles,
      affectAppTypeSpecificConfig,
    );
  }
  const finalMetaDataPayload : metaDataBatchPayload = {
    features: finalPayload
  }
  await validateWithOtp(
    async (verifiedUser?: manageUpdateAccessObj, verifyResponse?: any) => {
      try {
        if (verifyResponse.status >= 200 || verifyResponse.status < 300) {
          const validationObj = validateMetaDataResponse(
            verifyResponse?.data?.features
          );
          if (validationObj.success) {
            openPopup("Success", "Configuration Updated");
            actionPostSuccess();
          } else {
            openPopup("Error", validationObj.message);
          }
        } else {
          throw new Error("Something went wrong");
        }
      } catch (err) {
        if (err instanceof Error) openPopup("Error", err?.message);
      }
    },
    undefined,
    "admin", // TODO ask where to get this ( "all" / "admin" ) get this also from the local info
    META_DATA_BATCH_API,
    finalMetaDataPayload,
    apiType 
  );
};
const getFinalMetaDataPayload = (
  intialSelectedRole: OptionType,
  requiredConfigsMap: Record<string, any>,
  updatedConfigMap: Record<string, any>,
  initialConfigMap: Record<string, any>,
  selectedAppType: AppOptionType,
  selectedRoles: OptionType[],
  affectAppTypeSpecificConfig: boolean 
): updateConfigRequestBody[] => {
  // iterate over the keys of changedConfigMap , (where each key is a domainName) , no i will have different converted for each domainName and a default
  const finalPayload: updateConfigRequestBody[] = [];
  for (const domainName in updatedConfigMap) {
    let payload: updateConfigRequestBody[] = [];
    switch (domainName) {
      case "clientconfig":
        payload = getFinalPayloadForClientConfig(
          intialSelectedRole,
          requiredConfigsMap[domainName],
          updatedConfigMap[domainName],
          initialConfigMap[domainName],
          selectedAppType,
          selectedRoles,
          affectAppTypeSpecificConfig
        );
        break;
      default:
        payload = getFinalPayload(
          domainName,
          requiredConfigsMap[domainName],
          updatedConfigMap[domainName],
          initialConfigMap[domainName],
        //   selectedAppType,
        //   selectedRoles,
        //   affectAppTypeSpecificConfig
        );
        break;
    }
    finalPayload.push(...payload);
  }
  return finalPayload;
};
const getMergedConfigList = (
  updatedConfigList: Record<string, any>[],
  initialConfigList: Record<string, any>[]
): Record<string, any>[] => {
  updatedConfigList.forEach((config) => {
    const updatedConfigDomainValues = (config.domainValues ?? []).map(
      (val: Record<string, any>) => val.name
    );
    const initialConfigDomainValues = (
      initialConfigList.find((obj) => obj.domainType === config.domainType)
        ?.domainValues ?? []
    ).filter(
      (domVal: Record<string, any>) =>
        !updatedConfigDomainValues.includes(domVal.name)
    );
    config.domainValues = [
      ...initialConfigDomainValues,
      ...(config.domainValues || []),
    ];
  });
  return updatedConfigList;
};

const getFinalPayloadForClientConfig = (
  intialSelectedRole: OptionType,
  requiredConfigs: string[],
  updatedConfigList: Record<string, any>[],
  initialConfigList: Record<string, any>[],
  selectedAppType: AppOptionType,
  selectedRoles: OptionType[],
  affectAppTypeSpecificConfig: boolean
): updateConfigRequestBody[] => {
  const lob = getLob();
  // get the list of object that have changed and we need to add them 
  const changedConfigList = getChangedClientConfigList(initialConfigList,updatedConfigList,intialSelectedRole,requiredConfigs);
  const updatedDomainObjNameList = changedConfigList.map((obj: Record<string, any>) => obj.name);
  // now iterate over the selected roles 
  const finalPayload: updateConfigRequestBody[] = [];
  
  for (const role of selectedRoles) {
    // in initial config list find {role}_specific_config and update that payload 
    const roleSpecificConfigType = `${role.id}_specific_configuration`;
    const oldValues = initialConfigList.find(obj => obj.domainType === roleSpecificConfigType)?.domainValues || [];
    const newDomainValuesToAdd = changedConfigList;
    const initialDomainObjNames = oldValues.map((obj: Record<string, any>) => obj.name);

    const inOldButNotUpdated = oldValues.filter((obj: Record<string, any>) => !updatedDomainObjNameList.includes(obj.name));
    // take the old objects ( iterate over the old)
    const inUpdatedButNotOld = newDomainValuesToAdd.filter((obj: Record<string, any>) => !initialDomainObjNames.includes(obj.name));
    // take the updated object ( iterate over the updated)
    const inUpdatedAndOld = newDomainValuesToAdd.filter((obj: Record<string, any>) => initialDomainObjNames.includes(obj.name));
    // take the updated objects ( iterate over the updated)

    let mergedDomainValues: Record<string, any>[] = [];
    
    // Combine old values that weren't updated with updated values
    mergedDomainValues = [...inOldButNotUpdated, ...inUpdatedAndOld, ...inUpdatedButNotOld];
    
    
    // Create the payload for this role
    const rolePayload = {
      domainName: 'clientconfig',
      domainType: roleSpecificConfigType,
      domainValues: mergedDomainValues,
      lob: lob
    };
    
    finalPayload.push(rolePayload);
  }

  return finalPayload;
};

const getChangedClientConfigList = (initialData: Record<string, any>[],updateddata: Record<string, any>[],intialSelectedRole: OptionType,requiredConfigs: string[]): Record<string, any>[] => {
  const listOfChangedDomainValueObjects: Record<string, any>[] = [];
  for(const domainType of requiredConfigs){
      const domaineTypeToFind = `${intialSelectedRole.id}_${domainType}`;
      const domainObjUpdated = updateddata.find(obj => obj.domainType === domaineTypeToFind);
      const domainObjInitial = initialData.find(obj => obj.domainType === domaineTypeToFind);
      
      if (!domainObjInitial || !domainObjUpdated) continue;
      
      const domainValuesObjInInitial = domainObjInitial.domainValues.map((obj: Record<string, any>) => obj.name);
      const domainValuesObjInUpdated = domainObjUpdated.domainValues.map((obj: Record<string, any>) => obj.name);
      
      // not in updated so take the initial object and add a key in the object (removeConfig = true)
      // - iterate over the listOfDomainValueObjectNotInUpdated then find that object in initialdata.domainvalues 
      const listOfDomainValueObjectNotInUpdated = domainObjInitial.domainValues.filter((obj: Record<string, any>) => !domainValuesObjInUpdated.includes(obj.name));
      listOfDomainValueObjectNotInUpdated.forEach((domainValue: Record<string, any>) => {
          const objToAdd = { ...domainValue, removeConfig: true, domainType: domainType };
          listOfChangedDomainValueObjects.push(objToAdd);
      });
      
      // in updated but not in initial then take that object
      // - iterate over the listOfDomainValueObjectNotInInitial then find that object in updateddata.domainvalues 
      const listOfDomainValueObjectNotInInitial = domainObjUpdated.domainValues.filter((obj: Record<string, any>) => !domainValuesObjInInitial.includes(obj.name));
      listOfDomainValueObjectNotInInitial.forEach((domainValue: Record<string, any>) => {
          const objToAdd = { ...domainValue, domainType: domainType };
          listOfChangedDomainValueObjects.push(objToAdd);
      });
      
      // in both, but updated have different value then take that object
      // - iterate over updateddata.domainvalues and find that object in initial domainvalue and if the data is not equal then add that object in the listOfChangedDomainValueObjects
        domainObjUpdated.domainValues.forEach((updatedDomainValue: Record<string, any>) => {
          const initialDomainValue = domainObjInitial.domainValues.find((obj: Record<string, any>) => obj.name === updatedDomainValue.name);
          if (initialDomainValue && !isSame(initialDomainValue, updatedDomainValue)) {
              const objToAdd = { ...updatedDomainValue, domainType: domainType };
              listOfChangedDomainValueObjects.push(objToAdd);
          }
      });
  }
  return listOfChangedDomainValueObjects;
}
const isSame = (obj1: any,obj2: any) => {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}
const getFinalPayload = (
  domainName: string,
  requiredConfigs: string[],
  updatedConfigList: Record<string, any>[],
  initialConfigList: Record<string, any>[],
//   selectedAppType: AppOptionType,
//   selectedRoles: OptionType[],
//   affectAppTypeSpecificConfig: boolean
): updateConfigRequestBody[] => {

  const finalPayload: updateConfigRequestBody[] = [];
  const lob = getLob();
  for (const domainType of requiredConfigs) {
    const domainObj = updatedConfigList.find((obj: Record<string, any>) => obj.domainType === domainType);
    if(!domainObj || !domainObj!.domainValues) continue;
    const payloadObj: updateConfigRequestBody = {
      domainName,
      domainType: domainType,
      domainValues: domainObj!.domainValues,
      lob,
    };
    finalPayload.push(payloadObj);
  }
  return finalPayload;
};
const removeDesignationPrefix = (
  configList: Record<string, any>[],
  selectedRoles: OptionType[]
): Record<string, any>[] => {
  const designationPrefixFreeMap: Record<string, any>[] = [];
  for (const domainObj of configList) {
    const domainTypeParts = domainObj.domainType.split("_");
    const firstPart = domainTypeParts[0];
    
    // Check if the first part matches any selected role ID
    const shouldRemoveFirstPart = selectedRoles.some(role => role.id === firstPart);
    
    const newDomainType = shouldRemoveFirstPart 
      ? domainTypeParts.slice(1).join("_")
      : domainObj.domainType;
    
    designationPrefixFreeMap.push({
      ...domainObj,
      domainType: newDomainType,
    });
  }
  return designationPrefixFreeMap;
};

const getChangedConfigMap = (
  initialConfigMap: Record<string, any>,
  updatedConfigMap: Record<string, any>
): Record<string, any[]> => {
  const changedMap: Record<string, any[]> = {};
  // some issue here ( FIX THIS )
  for (const domainName in updatedConfigMap) {
    const updatedConfigs = updatedConfigMap[domainName];
    const initialConfigs = initialConfigMap[domainName] || [];

    const changesInDomain: any[] = [];

    for (const updatedConfig of updatedConfigs) {
      const { domainType, domainValues } = updatedConfig;

      const matchingInitial = initialConfigs.find(
        (c: any) => c.domainType === domainType
      );

      // If no match or deep mismatch in values, mark as changed
      if (
        !matchingInitial ||
        !deepEqual(domainValues, matchingInitial.domainValues)
      ) {
        changesInDomain.push(updatedConfig);
      }
    }

    if (changesInDomain.length > 0) {
      changedMap[domainName] = changesInDomain;
    }
  }

  return changedMap;
};

const deepEqual = (a: any, b: any): boolean => {
  if (a === b) return true;

  if (typeof a !== typeof b) return false;

  if (a === null || b === null) return a === b;

  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
      if (!deepEqual(a[i], b[i])) return false;
    }
    return true;
  }

  if (typeof a === "object" && typeof b === "object") {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);

    if (keysA.length !== keysB.length) return false;

    for (const key of keysA) {
      if (!b.hasOwnProperty(key)) return false;
      if (!deepEqual(a[key], b[key])) return false;
    }

    return true;
  }

  return false;
};
export const getMergedConfigMap = (
  updatedConfigMap: Record<string, any>,
  initialConfigMap: Record<string, any>
): Record<string, any> => {
  const mergedConfigMap: Record<string, any> = {};
  Object.keys(initialConfigMap).forEach((domainName) => {
    const initialDomainConfig = initialConfigMap[domainName];
    const updatedDomainConfig = updatedConfigMap[domainName];

    if (updatedDomainConfig) {
      // Both initial and updated exist — merge with updated taking priority
      const mergedDomainConfig = initialDomainConfig.map((initialItem: any) => {
        const matchingUpdatedItem = updatedDomainConfig.find(
          (item: any) => item.domainType === initialItem.domainType
        );

        if (matchingUpdatedItem) {
          // Merge domainValues by name, prioritize updated values
          const updatedValuesByName: Record<string, any> = {};
          matchingUpdatedItem.domainValues.forEach((val: any) => {
            updatedValuesByName[val.name] = val;
          });

          const mergedDomainValues = initialItem.domainValues.map(
            (val: any) => updatedValuesByName[val.name] || val
          );

          // Add any completely new domainValues from updated that didn't exist in initial
          const initialValueNames = new Set(
            initialItem.domainValues.map((v: any) => v.name)
          );
          matchingUpdatedItem.domainValues.forEach((val: any) => {
            if (!initialValueNames.has(val.name)) {
              mergedDomainValues.push(val);
            }
          });

          return {
            ...initialItem,
            ...matchingUpdatedItem, // in case there are other updated top-level keys
            domainValues: mergedDomainValues,
          };
        } else {
          // No update found, use initial
          return initialItem;
        }
      });

      // Also add any new domainTypes from updated that weren't in initial
      const initialTypes = new Set(
        initialDomainConfig.map((item: any) => item.domainType)
      );
      updatedDomainConfig.forEach((item: any) => {
        if (!initialTypes.has(item.domainType)) {
          mergedDomainConfig.push(item);
        }
      });

      mergedConfigMap[domainName] = mergedDomainConfig;
    } else {
      // No update for this domain, use initial config as-is
      mergedConfigMap[domainName] = initialDomainConfig;
    }
  });

  // Also include domains that exist only in updatedConfigMap
  Object.keys(updatedConfigMap).forEach((domainName) => {
    if (!mergedConfigMap.hasOwnProperty(domainName)) {
      mergedConfigMap[domainName] = updatedConfigMap[domainName];
    }
  });

  return mergedConfigMap;
};
export const getFlatenedConfigListMapWithUniqueDomainValues = (
  configObject: Record<string, any>
): Record<string, any> => {
  const configMap: Record<string, any> = {};

  if (!configObject || typeof configObject !== "object") {
    return configMap; // return empty if input is invalid
  }

  for (const domainName in configObject) {
    const configTemp = configObject[domainName];

    if (!Array.isArray(configTemp)) continue;

    for (const configObj of configTemp) {
      if (
        configObj &&
        typeof configObj === "object" &&
        typeof configObj.domainType === "string"
      ) {
        const domainType = configObj.domainType;
        const domainValues = Array.isArray(configObj.domainValues)
          ? configObj.domainValues
          : [];

        const visitedNames = new Set<string>();
        const uniqueDomainValues: any[] = [];

        for (const item of domainValues) {
          if (
            item &&
            typeof item === "object" &&
            typeof item.name === "string" &&
            !visitedNames.has(item.name)
          ) {
            visitedNames.add(item.name);
            uniqueDomainValues.push(item);
          }
        }

        configMap[domainType] = uniqueDomainValues;
      }
    }
  }

  return configMap;
};

export const updateConfigFeatureSelection = ( savedRole: OptionType, savedAppType: AppOptionType, uiConfigOptionsProp: otherConfigOptionsAttributes[], clientConfigRef: any , setUiConfigOptionsProp: React.Dispatch<React.SetStateAction<otherConfigOptionsAttributes[]>>,setAllConfigOptions: React.Dispatch<React.SetStateAction<otherConfigOptionsAttributes[]>>) => {
    if(!savedRole || !savedAppType || uiConfigOptionsProp.length === 0) return;
    
    const featureConfiguration = clientConfigRef.current.find(
      (obj: { domainType: string }) => {
        return obj.domainType === `${savedRole.id}_app_feature_configuration`;
      }
    ) as any;
    const featureConfigValue = featureConfiguration?.domainValues.find(
      (obj: { name: string }) => {
        return obj.name === "featureConfig";
      }
    ) as { value: any[] } ?? {};

    const featureList = featureConfigValue?.value?.map(
      (obj: { name: string }) => obj.name
    ) ?? [];

    const featureSet = new Set<string>(featureList);

    for (const uiConfigOption of uiConfigOptionsProp) {
      // if not mandatory but we have the feautre name in our featureConfig then we have selected it 
      if (!uiConfigOption.isMandatory && uiConfigOption.featureConfigName) {
        uiConfigOption.isSelected = featureSet.has(
          uiConfigOption.featureConfigName
        );
        uiConfigOption.action = undefined;
      }
      // if mandatory then we have selected it 
      if(uiConfigOption.isMandatory){
        uiConfigOption.isSelected = true;
      }
    }

    setUiConfigOptionsProp((_prev : any) => uiConfigOptionsProp);
    setAllConfigOptions([
      ...uiConfigOptionsProp.filter((obj : any) => obj?.supportedAppTypes?.includes(savedAppType?.id)),
    ]);
  };
export const getAllFeaturesForSelectedRole = (savedRole: OptionType,uiConfigOptionsProp: otherConfigOptionsAttributes[],clientConfigRef: any,savedAppType: AppOptionType) => {
  const featureConfiguration = clientConfigRef.current.find(
    (obj: { domainType: string }) => {
      return obj.domainType === `${savedRole.id}_app_feature_configuration`;
    }
  ) as any;
  const featureConfigValue = featureConfiguration?.domainValues.find(
    (obj: { name: string }) => {
      return obj.name === "featureConfig";
    }
  ) as { value: any[] } ?? {};

  const featureList = featureConfigValue?.value?.map(
    (obj: { name: string }) => obj.name
  ) ?? [];

  const featureSet = new Set<string>(featureList);

  for (const uiConfigOption of uiConfigOptionsProp) {
    // if not mandatory but we have the feautre name in our featureConfig then we have selected it 
    if (!uiConfigOption.isMandatory && uiConfigOption.featureConfigName) {
      uiConfigOption.isSelected = featureSet.has(
        uiConfigOption.featureConfigName
      );
      uiConfigOption.action = undefined;
    }
    // if mandatory then we have selected it 
    if(uiConfigOption.isMandatory){
      uiConfigOption.isSelected = true;
    }
  }
  const filteredFeatures = uiConfigOptionsProp.filter((obj : any) => obj?.hasOwnProperty('supportedAppTypes') || obj?.supportedAppTypes?.length === 0 || obj?.supportedAppTypes?.includes(savedAppType?.id));
  return filteredFeatures;
}
export const getFinalMetaDataPayloadFeatureSelection = (savedRole: OptionType, savedAppType: AppOptionType, uiConfigOptionsProp: otherConfigOptionsAttributes[], clientConfigRef: any, featureChangeList: string[]) => {
    const ensureConfigMappingInitialized = (domainType: string) => {
      if (!configMapping[domainType]) {
        const configuration = clientConfigRef.current.find(
          (obj: { domainType: string }) => obj.domainType === domainType
        ) as { domainValues: any[] } | undefined;

        configMapping[domainType] = configuration?.domainValues.map(val => ({ ...val })) || [];
      }
    };
    if (featureChangeList.length === 0) {
      return undefined;
    }

    const unVerifiedFeatures = uiConfigOptionsProp.filter(
      (obj : any) => !obj.isMandatory && obj.action
    );
    if (unVerifiedFeatures.length === 0) {
      return undefined;
    }

    const lob = getLob();
    const finalMetaDataPayload: metaDataBatchPayload = {
      features: [],
    };

    // Mapping configuration for both feature and layout configuration
    const featureConfiguration = structuredClone(
      clientConfigRef.current.find(
        (obj: any) =>
          obj.domainType === `${savedRole.id}_app_feature_configuration`
      ) as { domainValues: any[] } | undefined
    );

    const layoutConfiguration = structuredClone(
      clientConfigRef.current.find(
        (obj: any) =>
          obj.domainType === `${savedRole.id}_app_layout_configuration`
      ) as { domainValues: any[] } | undefined
    );

    const optionsConfiguration = structuredClone(
      clientConfigRef.current.find(
        (obj: any) =>
          obj.domainType === `${savedRole.id}_app_options_configuration`
      ) as { domainValues: any[] } | undefined
    );


    const configMapping: { [key: string]: any[] } = {
      [`${savedRole.id}_app_feature_configuration`]: featureConfiguration?.domainValues || [],
      [`${savedRole.id}_app_layout_configuration`]: layoutConfiguration?.domainValues || [],
      [`${savedRole.id}_app_options_configuration`]: optionsConfiguration?.domainValues || [],
    };

    // Check and initialize featureConfig if not present
    let featureConfigValue =
      configMapping[`${savedRole.id}_app_feature_configuration`].find(
        (obj: { name: string }) => obj.name === "featureConfig"
      ) as { value: any[] } | undefined;

    if (!featureConfigValue) {
      featureConfigValue = { value: [] }; // Initialize if undefined
      configMapping[`${savedRole.id}_app_feature_configuration`].push({
        name: "featureConfig",
        value: featureConfigValue.value,
      });
    }

    // Iterate over the unVerifiedFeatures
    for (let feature of unVerifiedFeatures) {
      const exists = featureConfigValue.value.some(
        (obj: { name: string }) => obj.name === feature.featureConfigName
      );

      // Handle feature config addition/removal
      const featureIndex = featureConfigValue.value.findIndex(
        (obj: { name: string }) => obj.name === feature.featureConfigName
      );

      if (feature.action === "added" && !exists) {
        featureConfigValue.value.push({
          name: feature.featureConfigName,
          version: "1.0",
          template: feature.addTemplate === true ? feature.featureConfigName : "",
          displayName: feature.id,
        });
      } else if (feature.action === "removed" && featureIndex !== -1) {
        featureConfigValue.value.splice(featureIndex, 1);
      }

      // Handle configMapping via domainValueHandlers
      for (let config of feature.additionalActivationConfigurations ?? []) {
        const domainType = `${savedRole.id}_${config.domainType}`;
        ensureConfigMappingInitialized(domainType);

        for (let domainObj of config.domainValues ?? []) {
          const index = configMapping[domainType].findIndex(
            (obj) => obj.name === domainObj.name
          );

          const customHandler = domainObj.customHandler?.[feature.action ?? ""];

          if (customHandler) {
            const handler = domainValueHandlers[customHandler.function];
            const customHandlerConfig = customHandler;

            if ("customHandler" in domainObj) {
              delete domainObj["customHandler"];
            }

            handler(
              index,
              domainObj,
              domainType,
              configMapping,
              customHandlerConfig
            );
          } else {
            // Default fallback behavior
            if (feature.action === "added") {
              if (index !== -1) {
                configMapping[domainType][index] = domainObj;
              } else {
                configMapping[domainType].push(domainObj);
              }
            } else if (feature.action === "removed" && index !== -1) {
              configMapping[domainType].splice(index, 1);
            }
          }
        }
      }
    }

    if (featureConfiguration) {
      for (let key in configMapping) {
        finalMetaDataPayload.features.push({
          domainName: "clientconfig",
          domainType: key,
          domainValues: configMapping[key],
          lob,
        });
      }
    }

    return finalMetaDataPayload;
  };

export const fetchAndSetUiConfigOptions = async (): Promise<otherConfigOptionsAttributes[]> => {
  const data = await getUiConfigOptions();
  const formattedData: any = data.map((item: any) => ({
    id: item.id,
    icon: item.icon,
    displayTemplateTwo: item.displayTemplateTwo,
    description: item.description,
    isSelected: item.isSelected,
    isActive: item.isActive,
    hintImage: item.hintImage,
    isMandatory: item.isMandatory,
    // role: item.role,
    supportedAppTypes: item.supportedAppTypes,
    isDeveloped: item.isDeveloped ?? false,
    featureConfigName: item.featureConfigName,
    addTemplate: item.addTemplate,
    additionalActivationConfigurations: item.additionalActivationConfigurations,
    appType: item.appType,
    label: item.label,
    subfeatures:item.subfeatures,
  }));

  return formattedData;
};
export const setAppSubscription = (setStandard: (standard: string) => void,clientConfig: any) => {
    const portal_config: configurationAttributeType[] = getConfigFromClientConfig(clientConfig,"portal_configuration") ?? [];
    const subscriptionType = portal_config?.find(
      (item) => item.name === "subscriptionType"
    )?.value;
    if (subscriptionType) {
      setStandard(subscriptionType);
    }
}
export const setClientConfigRef = async (clientConfigRef: any,setIsLoading: (isloader: boolean) => void) => {
  try {
    setIsLoading(true);
    const clientConfig = await getMetaDataConfig("clientconfig");
    clientConfigRef.current = clientConfig ?? [];
  } catch (err) {
    console.log(err);
    setIsLoading(false);
  } finally {
    setIsLoading(false);
  }
}
export const appSubscriptionCheck = (option: otherConfigOptionsAttributes ,standard: string | undefined) => {
  if(!option.appType){
    return true;
  }
  if(standard == undefined || standard == "standard"){
    return option.appType == "standard";
  }
  return option.appType == "nonstandard";
}
export const appSubscriptionCheckNew = (option: otherConfigOptionsAttributesFeature ,standard: string | undefined) => {
  if(!option.appType){
    return true;
  }
  if(standard == undefined || standard == "standard"){
    return option.appType == "standard";
  }
  return option.appType == "nonstandard";
}

export const featureSelectionScreenInit = async (setLoading: (isLoading: boolean) => void,clientConfigRef: any,setStandard: (standard: string) => void,setAppTypeOptions: (appTypeOptions: AppOptionType[]) => void,setRoleOptions: (roleOptions: OptionType[]) => void,uiConfigOptionsProp: otherConfigOptionsAttributes[],setUiConfigOptionsProp: React.Dispatch<React.SetStateAction<otherConfigOptionsAttributes[]>>,setAllConfigOptions: React.Dispatch<React.SetStateAction<otherConfigOptionsAttributes[]>>,savedRole: OptionType,savedAppType: AppOptionType) => {
  try{
    setLoading(true);
    await setClientConfigRef(clientConfigRef,setLoading);
    setAppSubscription(setStandard,clientConfigRef.current);
    const resp = setAppAndRoleOptions({
        setAppTypeOptions: setAppTypeOptions,
        setRoleOptions: setRoleOptions,
        clientConfig: clientConfigRef.current,
        savedRole: savedRole
    });
    updateConfigFeatureSelection(resp.role ?? savedRole,resp.appType ?? savedAppType,uiConfigOptionsProp,clientConfigRef,setUiConfigOptionsProp,setAllConfigOptions);
    }
    catch(err) {
      console.log("Error in init: ", err);
      openPopup("Error", "An error occurred while initializing the configuration. Please try again later.");
    }
    finally{
      setLoading(false);
    }
}